var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.ts
import { makeHttpClient } from "@wise/dynamic-flow-client";
import { JsonSchemaForm, isValidSchema, findRendererPropsByType } from "@wise/dynamic-flow-client";

// src/i18n/index.ts
import { translations as coreTranslations } from "@wise/dynamic-flow-client";

// src/i18n/de.json
var de_default = {
  "df.wise.ArraySchema.addItem": "Speichern",
  "df.wise.ArraySchema.addItemTitle": "Artikel hinzuf\xFCgen",
  "df.wise.ArraySchema.editItem": "Speichern",
  "df.wise.ArraySchema.maxItemsError": "Bitte f\xFCge {maxItems} oder weniger hinzu.",
  "df.wise.ArraySchema.minItemsError": "Bitte f\xFCge mindestens {minItems} hinzu.",
  "df.wise.ArraySchema.removeItem": "Entfernen",
  "df.wise.ControlFeedback.maxLength": "Bitte gib nicht mehr als {maxLength} Zeichen ein.",
  "df.wise.ControlFeedback.maximum": "Bitte gib eine Zahl ein, die {maximum} oder weniger betr\xE4gt.",
  "df.wise.ControlFeedback.maximumDate": "Bitte gib ein Datum ein, das am oder vor dem {maximum} liegt.",
  "df.wise.ControlFeedback.minLength": "Bitte gib mindestens {minLength} Zeichen ein.",
  "df.wise.ControlFeedback.minimum": "Bitte gib eine Zahl ein, die {minimum} oder mehr betr\xE4gt.",
  "df.wise.ControlFeedback.minimumDate": "Bitte gib ein Datum ein, das am oder nach dem {minimum} liegt.",
  "df.wise.ControlFeedback.pattern": "Bitte gib die Angabe im richtigen Format ein.",
  "df.wise.ControlFeedback.patternDate": "Bitte gib ein Datum im richtigen Format ein.",
  "df.wise.ControlFeedback.required": "Bitte f\xFClle dieses Feld aus.",
  "df.wise.ControlFeedback.type": "Falscher Typ",
  "df.wise.DynamicParagraph.copied": "In Zwischenablage kopiert",
  "df.wise.DynamicParagraph.copy": "Kopieren",
  "df.wise.ErrorBoundary.errorAlert": "Da ist etwas schiefgegangen.",
  "df.wise.ErrorBoundary.retry": "Erneut versuchen",
  "df.wise.ExternalConfirmation.cancel": "Abbrechen",
  "df.wise.ExternalConfirmation.description": "Bitte best\xE4tige, dass du **{origin}** in einem neuen Browser-Tab \xF6ffnen m\xF6chtest.",
  "df.wise.ExternalConfirmation.open": "In neuem Tab \xF6ffnen",
  "df.wise.ExternalConfirmation.title": "Bitte best\xE4tigen",
  "df.wise.Help.ariaLabel": "Klicke hier f\xFCr mehr Informationen.",
  "df.wise.MultiSelect.summary": "{first} und {count} weitere",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Diese Datei ist leider zu gro\xDF. Bitte lade eine kleinere Datei hoch.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Bitte lade {maxItems} oder weniger Dateien hoch.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Bitte lade mindestens {minItems} Datei(en) hoch.",
  "df.wise.PersistAsyncSchema.genericError": "Da ist etwas schiefgegangen. Versuche es bitte nochmal.",
  "df.wise.SearchLayout.loading": "L\xE4dt..."
};

// src/i18n/en.json
var en_default = {
  "df.wise.ArraySchema.addItem": "Save",
  "df.wise.ArraySchema.addItemTitle": "Add Item",
  "df.wise.ArraySchema.editItem": "Save",
  "df.wise.ArraySchema.maxItemsError": "Please add {maxItems} or fewer.",
  "df.wise.ArraySchema.minItemsError": "Please add at least {minItems}.",
  "df.wise.ArraySchema.removeItem": "Remove",
  "df.wise.ControlFeedback.maxLength": "Please enter {maxLength} or fewer characters.",
  "df.wise.ControlFeedback.maximum": "Please enter a number that's {maximum} or less.",
  "df.wise.ControlFeedback.maximumDate": "Please enter a date that's on or before {maximum}.",
  "df.wise.ControlFeedback.minLength": "Please enter at least {minLength} characters.",
  "df.wise.ControlFeedback.minimum": "Please enter a number that's {minimum} or more.",
  "df.wise.ControlFeedback.minimumDate": "Please enter a date that's on or after {minimum}.",
  "df.wise.ControlFeedback.pattern": "Please enter this in the correct format.",
  "df.wise.ControlFeedback.patternDate": "Please enter a date in the corrrect format.",
  "df.wise.ControlFeedback.required": "Please fill out this field.",
  "df.wise.ControlFeedback.type": "Incorrect type",
  "df.wise.DynamicParagraph.copied": "Copied to clipboard",
  "df.wise.DynamicParagraph.copy": "Copy",
  "df.wise.ErrorBoundary.errorAlert": "Something went wrong.",
  "df.wise.ErrorBoundary.retry": "Retry",
  "df.wise.ExternalConfirmation.cancel": "Cancel",
  "df.wise.ExternalConfirmation.description": "Please confirm you want to open **{origin}** in a new browser tab.",
  "df.wise.ExternalConfirmation.open": "Open in new tab",
  "df.wise.ExternalConfirmation.title": "Please confirm",
  "df.wise.Help.ariaLabel": "Click here for more info.",
  "df.wise.MultiSelect.summary": "{first} and {count} more",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Sorry, that file is too big. Please upload a smaller file.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Please upload {maxItems} or fewer files.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Please upload at least {minItems} file(s).",
  "df.wise.PersistAsyncSchema.genericError": "Something went wrong, please try again.",
  "df.wise.SearchLayout.loading": "Loading..."
};

// src/i18n/es.json
var es_default = {
  "df.wise.ArraySchema.addItem": "Guardar",
  "df.wise.ArraySchema.addItemTitle": "A\xF1adir elemento",
  "df.wise.ArraySchema.editItem": "Guardar",
  "df.wise.ArraySchema.maxItemsError": "A\xF1ade {maxItems} o menos.",
  "df.wise.ArraySchema.minItemsError": "A\xF1ade al menos {minItems}.",
  "df.wise.ArraySchema.removeItem": "Eliminar",
  "df.wise.ControlFeedback.maxLength": "Introduce {maxLength} caracteres o menos.",
  "df.wise.ControlFeedback.maximum": "Introduce una cifra igual o inferior a {maximum}.",
  "df.wise.ControlFeedback.maximumDate": "Introduce una fecha que sea igual o anterior al {maximum}.",
  "df.wise.ControlFeedback.minLength": "Introduce al menos {minLength} caracteres.",
  "df.wise.ControlFeedback.minimum": "Introduce una cifra igual o inferior a {minimum}.",
  "df.wise.ControlFeedback.minimumDate": "Introduce una fecha que sea igual o posterior al {minimum}.",
  "df.wise.ControlFeedback.pattern": "Utiliza el formato correcto.",
  "df.wise.ControlFeedback.patternDate": "Introduce la fecha en un formato correcto.",
  "df.wise.ControlFeedback.required": "Completa este campo.",
  "df.wise.ControlFeedback.type": "Tipo incorrecto",
  "df.wise.DynamicParagraph.copied": "Copiado al portapapeles",
  "df.wise.DynamicParagraph.copy": "Copiar",
  "df.wise.ErrorBoundary.errorAlert": "Ha habido un error.",
  "df.wise.ErrorBoundary.retry": "Reintentar",
  "df.wise.ExternalConfirmation.cancel": "Cancelar",
  "df.wise.ExternalConfirmation.description": "Confirma que quieres abrir **{origin}** en una nueva pesta\xF1a del navegador.",
  "df.wise.ExternalConfirmation.open": "Abrir en nueva pesta\xF1a",
  "df.wise.ExternalConfirmation.title": "Por favor, confirma",
  "df.wise.Help.ariaLabel": "Haz clic aqu\xED para obtener m\xE1s informaci\xF3n.",
  "df.wise.MultiSelect.summary": "{first} y {count} m\xE1s",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Lo sentimos, el archivo pesa demasiado. Sube uno m\xE1s peque\xF1o.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Sube {maxItems} o menos archivos.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Sube al menos {minItems} archivo(s).",
  "df.wise.PersistAsyncSchema.genericError": "Ha habido un error. Int\xE9ntalo de nuevo.",
  "df.wise.SearchLayout.loading": "Cargando..."
};

// src/i18n/fr.json
var fr_default = {
  "df.wise.ArraySchema.addItem": "Enregistrer",
  "df.wise.ArraySchema.addItemTitle": "Ajouter un \xE9l\xE9ment",
  "df.wise.ArraySchema.editItem": "Enregistrer",
  "df.wise.ArraySchema.maxItemsError": "Veuillez ajouter {maxItems} ou moins.",
  "df.wise.ArraySchema.minItemsError": "Veuillez ajouter au moins {minItems}.",
  "df.wise.ArraySchema.removeItem": "Supprimer",
  "df.wise.ControlFeedback.maxLength": "Veuillez saisir {maxLength} caract\xE8res ou moins.",
  "df.wise.ControlFeedback.maximum": "Veuillez saisir un nombre inf\xE9rieur ou \xE9gal \xE0 {maximum}.",
  "df.wise.ControlFeedback.maximumDate": "Veuillez saisir une date \xE9gale ou ant\xE9rieure au {maximum}.",
  "df.wise.ControlFeedback.minLength": "Veuillez saisir au moins {minLength} caract\xE8res.",
  "df.wise.ControlFeedback.minimum": "Veuillez saisir un nombre sup\xE9rieur ou \xE9gal \xE0 {minimum}.",
  "df.wise.ControlFeedback.minimumDate": "Veuillez saisir une date \xE9gale ou post\xE9rieure au {minimum}.",
  "df.wise.ControlFeedback.pattern": "Veuillez saisir les informations dans le bon format.",
  "df.wise.ControlFeedback.patternDate": "Veuillez saisir une date au format correct.",
  "df.wise.ControlFeedback.required": "Champ obligatoire.",
  "df.wise.ControlFeedback.type": "Type incorrect",
  "df.wise.DynamicParagraph.copied": "Copi\xE9 dans le presse-papier",
  "df.wise.DynamicParagraph.copy": "Copier",
  "df.wise.ErrorBoundary.errorAlert": "Une erreur s'est produite.",
  "df.wise.ErrorBoundary.retry": "R\xE9essayer",
  "df.wise.ExternalConfirmation.cancel": "Annuler",
  "df.wise.ExternalConfirmation.description": "Veuillez confirmer que vous souhaitez ouvrir **{origin}** dans un nouvel onglet.",
  "df.wise.ExternalConfirmation.open": "Ouvrir dans un nouvel onglet",
  "df.wise.ExternalConfirmation.title": "Veuillez confirmer",
  "df.wise.Help.ariaLabel": "Cliquez ici pour plus d'informations.",
  "df.wise.MultiSelect.summary": "{first} et {count} de plus",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Nous sommes d\xE9sol\xE9s, ce fichier est trop volumineux. Veuillez t\xE9l\xE9charger un fichier plus petit.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Veuillez t\xE9l\xE9charger {maxItems} fichiers ou moins.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Veuillez t\xE9l\xE9charger au moins {minItems} fichier(s).",
  "df.wise.PersistAsyncSchema.genericError": "Une erreur s'est produite, veuillez r\xE9essayer.",
  "df.wise.SearchLayout.loading": "Chargement..."
};

// src/i18n/hu.json
var hu_default = {
  "df.wise.ArraySchema.addItem": "Ment\xE9s",
  "df.wise.ArraySchema.addItemTitle": "Elem hozz\xE1ad\xE1sa",
  "df.wise.ArraySchema.editItem": "Ment\xE9s",
  "df.wise.ArraySchema.maxItemsError": "K\xE9r\xFCnk, {maxItems} vagy ann\xE1l kevesebb t\xE9telt adj meg.",
  "df.wise.ArraySchema.minItemsError": "K\xE9r\xFCnk, legal\xE1bb {minItems} t\xE9telt adj meg.",
  "df.wise.ArraySchema.removeItem": "Elt\xE1vol\xEDt\xE1s",
  "df.wise.ControlFeedback.maxLength": "K\xE9r\xFCnk, legfeljebb {maxLength} karaktert adj meg.",
  "df.wise.ControlFeedback.maximum": "K\xE9r\xFCnk, add meg ezt vagy egy enn\xE9l kisebb sz\xE1mot: {maximum}.",
  "df.wise.ControlFeedback.maximumDate": "K\xE9r\xFCnk, adj meg egy d\xE1tumot, ami megegyezik {maximum} napj\xE1val, vagy egy enn\xE9l kor\xE1bbit.",
  "df.wise.ControlFeedback.minLength": "K\xE9r\xFCnk, legal\xE1bb {minLength} karaktert adj meg.",
  "df.wise.ControlFeedback.minimum": "K\xE9r\xFCnk add meg ezt vagy egy enn\xE9l nagyobb sz\xE1mot: {minimum}.",
  "df.wise.ControlFeedback.minimumDate": "K\xE9r\xFCnk, adj meg egy d\xE1tumot, ami megegyezik {minimum} napj\xE1val, vagy egy enn\xE9l k\xE9s\u0151bbit.",
  "df.wise.ControlFeedback.pattern": "Helytelen form\xE1tum",
  "df.wise.ControlFeedback.patternDate": "K\xE9r\xFCnk, hogy a d\xE1tumot helyes form\xE1tumban add meg.",
  "df.wise.ControlFeedback.required": "K\xE9r\xFCnk, t\xF6ltsd ki ezt a mez\u0151t.",
  "df.wise.ControlFeedback.type": "Helytelen t\xEDpus",
  "df.wise.DynamicParagraph.copied": "V\xE1g\xF3lapra m\xE1solva",
  "df.wise.DynamicParagraph.copy": "M\xE1sol\xE1s",
  "df.wise.ErrorBoundary.errorAlert": "Valami hiba t\xF6rt\xE9nt.",
  "df.wise.ErrorBoundary.retry": "\xDAjra",
  "df.wise.ExternalConfirmation.cancel": "M\xE9gsem",
  "df.wise.ExternalConfirmation.description": "K\xE9r\xFCnk, er\u0151s\xEDtsd meg, hogy a(z) **{origin}** alkalmaz\xE1st egy \xFAj b\xF6ng\xE9sz\u0151lapon szeretn\xE9d megnyitni.",
  "df.wise.ExternalConfirmation.open": "Megnyit\xE1s \xFAj lapon",
  "df.wise.ExternalConfirmation.title": "Meger\u0151s\xEDt\xE9s",
  "df.wise.Help.ariaLabel": "Kattints ide tov\xE1bbi inform\xE1ci\xF3\xE9rt.",
  "df.wise.MultiSelect.summary": "{first} \xE9s tov\xE1bbi {count}",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Sajnos ez a f\xE1jl t\xFAl nagy. K\xE9r\xFCnk, t\xF6lts fel egy kisebb f\xE1jlt.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "K\xE9r\xFCnk, hogy legfeljebb {maxItems} f\xE1jlt t\xF6lts fel.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "K\xE9r\xFCnk, hogy legal\xE1bb {minItems} f\xE1jlt t\xF6lts fel.",
  "df.wise.PersistAsyncSchema.genericError": "Valami hiba t\xF6rt\xE9nt. K\xE9r\xFCnk, pr\xF3b\xE1ld \xFAjra.",
  "df.wise.SearchLayout.loading": "Bet\xF6lt\xE9s..."
};

// src/i18n/id.json
var id_default = {
  "df.wise.ArraySchema.addItem": "Simpan",
  "df.wise.ArraySchema.addItemTitle": "Tambahkan Item",
  "df.wise.ArraySchema.editItem": "Simpan",
  "df.wise.ArraySchema.maxItemsError": "Harap tambahkan {maxItems} atau kurang.",
  "df.wise.ArraySchema.minItemsError": "Harap tambahkan setidaknya {minItems}.",
  "df.wise.ArraySchema.removeItem": "Hapus",
  "df.wise.ControlFeedback.maxLength": "Harap masukkan {maxLength} karakter atau kurang.",
  "df.wise.ControlFeedback.maximum": "Harap masukkan angka paling besar {maximum} atau kurang dari itu.",
  "df.wise.ControlFeedback.maximumDate": "Harap masukkan tanggal pada atau sebelum {maximum}.",
  "df.wise.ControlFeedback.minLength": "Harap masukkan setidaknya {minLength} karakter.",
  "df.wise.ControlFeedback.minimum": "Harap masukkan angka paling kecil {minimum} atau lebih dari itu.",
  "df.wise.ControlFeedback.minimumDate": "Harap masukkan tanggal pada atau setelah {minimum}.",
  "df.wise.ControlFeedback.pattern": "Mohon masukkan ini dalam format yang benar.",
  "df.wise.ControlFeedback.patternDate": "Harap masukkan tanggal dalam format yang benar.",
  "df.wise.ControlFeedback.required": "Harap isi kolom ini.",
  "df.wise.ControlFeedback.type": "Tipe salah",
  "df.wise.DynamicParagraph.copied": "Disalin ke clipboard",
  "df.wise.DynamicParagraph.copy": "Salin",
  "df.wise.ErrorBoundary.errorAlert": "Terjadi kesalahan.",
  "df.wise.ErrorBoundary.retry": "Coba lagi",
  "df.wise.ExternalConfirmation.cancel": "Batalkan",
  "df.wise.ExternalConfirmation.description": "Harap konfirmasikan bahwa Anda ingin membuka **{origin}** di tab browser baru.",
  "df.wise.ExternalConfirmation.open": "Buka di tab baru",
  "df.wise.ExternalConfirmation.title": "Harap konfirmasi",
  "df.wise.Help.ariaLabel": "Klik di sini untuk info selengkapnya.",
  "df.wise.MultiSelect.summary": "{first} dan {count} lagi",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Maaf, file Anda terlalu besar. Silakan unggah file yang lebih kecil.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Harap unggah {maxItems} file atau kurang.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Harap unggah sedikitnya {minItems} file.",
  "df.wise.PersistAsyncSchema.genericError": "Terjadi kesalahan, mohon coba lagi.",
  "df.wise.SearchLayout.loading": "Memuat ..."
};

// src/i18n/it.json
var it_default = {
  "df.wise.ArraySchema.addItem": "Salva",
  "df.wise.ArraySchema.addItemTitle": "Aggiungi elemento",
  "df.wise.ArraySchema.editItem": "Salva",
  "df.wise.ArraySchema.maxItemsError": "Aggiungi al massimo {maxItems}.",
  "df.wise.ArraySchema.minItemsError": "Aggiungi almeno {minItems}.",
  "df.wise.ArraySchema.removeItem": "Rimuovi",
  "df.wise.ControlFeedback.maxLength": "Inserisci un massimo di {maxLength} caratteri.",
  "df.wise.ControlFeedback.maximum": "Inserisci un numero uguale o inferiore a {maximum}.",
  "df.wise.ControlFeedback.maximumDate": "Inserisci una data corrispondente o precedente al {maximum}.",
  "df.wise.ControlFeedback.minLength": "Inserisci almeno {minLength} caratteri.",
  "df.wise.ControlFeedback.minimum": "Inserisci un numero uguale o superiore a {minimum}.",
  "df.wise.ControlFeedback.minimumDate": "Inserisci una data corrispondente o successiva al {minimum}.",
  "df.wise.ControlFeedback.pattern": "Inseriscilo in un formato corretto.",
  "df.wise.ControlFeedback.patternDate": "Inserisci la data in un formato corretto.",
  "df.wise.ControlFeedback.required": "Compila questo campo.",
  "df.wise.ControlFeedback.type": "Tipo errato",
  "df.wise.DynamicParagraph.copied": "Copiato negli appunti",
  "df.wise.DynamicParagraph.copy": "Copia",
  "df.wise.ErrorBoundary.errorAlert": "Qualcosa non ha funzionato.",
  "df.wise.ErrorBoundary.retry": "Riprova",
  "df.wise.ExternalConfirmation.cancel": "Annulla",
  "df.wise.ExternalConfirmation.description": "Conferma di voler aprire **{origin}** in una nuova scheda del browser.",
  "df.wise.ExternalConfirmation.open": "Apri in una nuova scheda",
  "df.wise.ExternalConfirmation.title": "Conferma",
  "df.wise.Help.ariaLabel": "Clicca qui per maggiori informazioni.",
  "df.wise.MultiSelect.summary": "{first} e altri {count}",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Spiacenti, il file \xE8 troppo grande. Carica un file di dimensioni inferiori.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Carica al massimo {maxItems} file.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Carica almeno {minItems} file.",
  "df.wise.PersistAsyncSchema.genericError": "Qualcosa \xE8 andato storto. Riprova.",
  "df.wise.SearchLayout.loading": "Caricamento..."
};

// src/i18n/ja.json
var ja_default = {
  "df.wise.ArraySchema.addItem": "\u4FDD\u5B58\u3059\u308B",
  "df.wise.ArraySchema.addItemTitle": "\u30A2\u30A4\u30C6\u30E0\u3092\u8FFD\u52A0\u3059\u308B",
  "df.wise.ArraySchema.editItem": "\u4FDD\u5B58\u3059\u308B",
  "df.wise.ArraySchema.maxItemsError": "{maxItems}\u30A2\u30A4\u30C6\u30E0\u4EE5\u4E0B\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ArraySchema.minItemsError": "{minItems}\u30A2\u30A4\u30C6\u30E0\u4EE5\u4E0A\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ArraySchema.removeItem": "\u524A\u9664\u3059\u308B",
  "df.wise.ControlFeedback.maxLength": "{maxLength}\u6587\u5B57\u4EE5\u4E0B\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.maximum": "{maximum}\u4EE5\u4E0B\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.maximumDate": "{maximum}\u307E\u305F\u306F\u305D\u308C\u4EE5\u524D\u306E\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.minLength": "{minLength}\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.minimum": "{minimum}\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.minimumDate": "{minimum}\u307E\u305F\u306F\u305D\u308C\u4EE5\u964D\u306E\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.pattern": "\u6B63\u3057\u3044\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.patternDate": "\u6B63\u3057\u3044\u5F62\u5F0F\u3067\u65E5\u4ED8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ControlFeedback.required": "\u3053\u306E\u9805\u76EE\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059\u3002",
  "df.wise.ControlFeedback.type": "\u4E0D\u6B63\u306A\u30BF\u30A4\u30D7",
  "df.wise.DynamicParagraph.copied": "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3078\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
  "df.wise.DynamicParagraph.copy": "\u30B3\u30D4\u30FC\u3059\u308B",
  "df.wise.ErrorBoundary.errorAlert": "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
  "df.wise.ErrorBoundary.retry": "\u3084\u308A\u76F4\u3059",
  "df.wise.ExternalConfirmation.cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B",
  "df.wise.ExternalConfirmation.description": "\u65B0\u3057\u3044\u30D6\u30E9\u30A6\u30B6\u30BF\u30D6\u3067**{origin}**\u3092\u958B\u304F\u3053\u3068\u3092\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.ExternalConfirmation.open": "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
  "df.wise.ExternalConfirmation.title": "\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044",
  "df.wise.Help.ariaLabel": "\u8A73\u7D30\u306F\u3053\u3061\u3089\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.MultiSelect.summary": "{first}\u3068\u305D\u306E\u4ED6{count}",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\u5927\u5909\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u304C\u3001\u30D5\u30A1\u30A4\u30EB\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002\u3053\u308C\u3088\u308A\u5C0F\u3055\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "{maxItems}\u500B\u4EE5\u4E0B\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.MultipleFileUploadSchema.minItemsError": "{minItems}\u500B\u4EE5\u4E0A\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "df.wise.PersistAsyncSchema.genericError": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
  "df.wise.SearchLayout.loading": "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026"
};

// src/i18n/pl.json
var pl_default = {
  "df.wise.ArraySchema.addItem": "Zapisz",
  "df.wise.ArraySchema.addItemTitle": "Dodaj pozycj\u0119",
  "df.wise.ArraySchema.editItem": "Zapisz",
  "df.wise.ArraySchema.maxItemsError": "Prosimy doda\u0107 maksymalnie {maxItems}.",
  "df.wise.ArraySchema.minItemsError": "Prosimy doda\u0107 co najmniej {minItems}.",
  "df.wise.ArraySchema.removeItem": "Usu\u0144",
  "df.wise.ControlFeedback.maxLength": "Prosimy wprowadzi\u0107 do {maxLength} znak\xF3w.",
  "df.wise.ControlFeedback.maximum": "Wprowad\u017A liczb\u0119 r\xF3wn\u0105 lub mniejsz\u0105 ni\u017C {maximum}.",
  "df.wise.ControlFeedback.maximumDate": "Wprowad\u017A dat\u0119 nie p\xF3\u017Aniejsz\u0105 ni\u017C {maximum}.",
  "df.wise.ControlFeedback.minLength": "Prosz\u0119 wpisa\u0107 co najmniej {minLength} znak\xF3w.",
  "df.wise.ControlFeedback.minimum": "Wprowad\u017A liczb\u0119 r\xF3wn\u0105 lub wi\u0119ksz\u0105 ni\u017C {minimum}.",
  "df.wise.ControlFeedback.minimumDate": "Wprowad\u017A dat\u0119 nie wcze\u015Bniejsz\u0105 ni\u017C {minimum}.",
  "df.wise.ControlFeedback.pattern": "Wprowad\u017A t\u0119 warto\u015B\u0107 w prawid\u0142owym formacie.",
  "df.wise.ControlFeedback.patternDate": "Wprowad\u017A dat\u0119 w prawid\u0142owym formacie.",
  "df.wise.ControlFeedback.required": "Prosz\u0119 wype\u0142ni\u0107 to pole.",
  "df.wise.ControlFeedback.type": "Nieprawid\u0142owy typ",
  "df.wise.DynamicParagraph.copied": "Skopiowano do schowka",
  "df.wise.DynamicParagraph.copy": "Kopiuj",
  "df.wise.ErrorBoundary.errorAlert": "Co\u015B posz\u0142o nie tak.",
  "df.wise.ErrorBoundary.retry": "Spr\xF3buj ponownie",
  "df.wise.ExternalConfirmation.cancel": "Anuluj",
  "df.wise.ExternalConfirmation.description": "Prosimy potwierdzi\u0107, \u017Ce chcesz otworzy\u0107 **{origin}** w nowej zak\u0142adce przegl\u0105darki.",
  "df.wise.ExternalConfirmation.open": "Otw\xF3rz w nowej zak\u0142adce",
  "df.wise.ExternalConfirmation.title": "Potwierd\u017A",
  "df.wise.Help.ariaLabel": "Kliknij tutaj, \u017Ceby uzyska\u0107 wi\u0119cej informacji.",
  "df.wise.MultiSelect.summary": "{first} oraz {count} wi\u0119cej",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Przepraszamy, ten plik jest zbyt du\u017Cy. Prze\u015Blij mniejszy plik.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Prze\u015Blij do {maxItems} plik\xF3w.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Prze\u015Blij co najmniej nast\u0119puj\u0105c\u0105 liczb\u0119 plik\xF3w: {minItems}.",
  "df.wise.PersistAsyncSchema.genericError": "Wyst\u0105pi\u0142 b\u0142\u0105d, prosimy spr\xF3bowa\u0107 ponownie.",
  "df.wise.SearchLayout.loading": "\u0141adowanie..."
};

// src/i18n/pt.json
var pt_default = {
  "df.wise.ArraySchema.addItem": "Salvar",
  "df.wise.ArraySchema.addItemTitle": "Adicionar item",
  "df.wise.ArraySchema.editItem": "Salvar",
  "df.wise.ArraySchema.maxItemsError": "Adicione {maxItems} ou menos.",
  "df.wise.ArraySchema.minItemsError": "Adicione pelo menos {minItems}.",
  "df.wise.ArraySchema.removeItem": "Remover",
  "df.wise.ControlFeedback.maxLength": "Por favor, insira {maxLength} caracteres ou menos.",
  "df.wise.ControlFeedback.maximum": "Por favor, insira um n\xFAmero que seja {maximum} ou menos.",
  "df.wise.ControlFeedback.maximumDate": "Por favor, insira uma data que seja em ou antes de {maximum}.",
  "df.wise.ControlFeedback.minLength": "Por favor, insira pelo menos {minLength} caracteres.",
  "df.wise.ControlFeedback.minimum": "Por favor, insira um n\xFAmero que seja {minimum} ou mais.",
  "df.wise.ControlFeedback.minimumDate": "Por favor, insira uma data que seja em ou ap\xF3s {minimum}.",
  "df.wise.ControlFeedback.pattern": "Por favor, insira essa informa\xE7\xE3o no formato correto.",
  "df.wise.ControlFeedback.patternDate": "Por favor, insira a data no formato correto.",
  "df.wise.ControlFeedback.required": "Por favor, preencha o campo.",
  "df.wise.ControlFeedback.type": "Tipo incorreto",
  "df.wise.DynamicParagraph.copied": "Copiado",
  "df.wise.DynamicParagraph.copy": "Copiar",
  "df.wise.ErrorBoundary.errorAlert": "Algo deu errado.",
  "df.wise.ErrorBoundary.retry": "Tentar novamente",
  "df.wise.ExternalConfirmation.cancel": "Cancelar",
  "df.wise.ExternalConfirmation.description": "Por favor, confirme que deseja abrir * *{origin}* * em uma nova aba do navegador.",
  "df.wise.ExternalConfirmation.open": "Abrir em uma nova aba",
  "df.wise.ExternalConfirmation.title": "Por favor, confirme",
  "df.wise.Help.ariaLabel": "Clique aqui para mais informa\xE7\xF5es.",
  "df.wise.MultiSelect.summary": "{first} e mais {count} ",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Este arquivo \xE9 muito grande. Por favor, envie um arquivo menor.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Por favor, envie {maxItems} ou menos arquivos.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Por favor, envie pelo menos {minItems} arquivo(s).",
  "df.wise.PersistAsyncSchema.genericError": "Ocorreu um erro. Por favor, tente novamente.",
  "df.wise.SearchLayout.loading": "Carregando..."
};

// src/i18n/ro.json
var ro_default = {
  "df.wise.ArraySchema.addItem": "Salvare",
  "df.wise.ArraySchema.addItemTitle": "Adaug\u0103 produs",
  "df.wise.ArraySchema.editItem": "Salvare",
  "df.wise.ArraySchema.maxItemsError": "Te rug\u0103m s\u0103 adaugi {maxItems} sau mai pu\u021Bine.",
  "df.wise.ArraySchema.minItemsError": "Te rug\u0103m s\u0103 adaugi cel pu\u021Bin {minItems}.",
  "df.wise.ArraySchema.removeItem": "Elimin\u0103",
  "df.wise.ControlFeedback.maxLength": "Te rug\u0103m s\u0103 introduci {maxLength} sau mai pu\u021Bine caractere.",
  "df.wise.ControlFeedback.maximum": "Te rug\u0103m s\u0103 introduci un num\u0103r egal cu {maximum} sau mai mic.",
  "df.wise.ControlFeedback.maximumDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 de \xEEnainte de sau egal\u0103 cu {maximum}.",
  "df.wise.ControlFeedback.minLength": "Te rug\u0103m s\u0103 introduci cel pu\u021Bin {minLength} caractere.",
  "df.wise.ControlFeedback.minimum": "Te rug\u0103m s\u0103 introduci un num\u0103r egal cu {minimum} sau mai mare.",
  "df.wise.ControlFeedback.minimumDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 de dup\u0103 sau egal\u0103 cu {minimum}.",
  "df.wise.ControlFeedback.pattern": "Te rug\u0103m s\u0103 introduci acest lucru \xEEn formatul corect.",
  "df.wise.ControlFeedback.patternDate": "Te rug\u0103m s\u0103 introduci o dat\u0103 \xEEn formatul corect.",
  "df.wise.ControlFeedback.required": "Te rug\u0103m s\u0103 completezi acest spa\u021Biu.",
  "df.wise.ControlFeedback.type": "Tip incorect",
  "df.wise.DynamicParagraph.copied": "Copiat \xEEn clipboard",
  "df.wise.DynamicParagraph.copy": "Copiaz\u0103",
  "df.wise.ErrorBoundary.errorAlert": "Ceva nu a mers bine.",
  "df.wise.ErrorBoundary.retry": "\xCEncearc\u0103 din nou",
  "df.wise.ExternalConfirmation.cancel": "Anuleaz\u0103",
  "df.wise.ExternalConfirmation.description": "Te rug\u0103m s\u0103 confirmi c\u0103 vrei s\u0103 deschizi **{origin}** \xEEntr-o nou\u0103 fil\u0103 a browserului.",
  "df.wise.ExternalConfirmation.open": "Deschide \xEEntr-o fil\u0103 nou\u0103",
  "df.wise.ExternalConfirmation.title": "Te rug\u0103m s\u0103 confirmi",
  "df.wise.Help.ariaLabel": "D\u0103 click aici pentru mai multe informa\u021Bii.",
  "df.wise.MultiSelect.summary": "{first} \u0219i \xEEnc\u0103 {count}",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "Ne pare r\u0103u, acel fi\u0219ier este prea mare. Te rug\u0103m s\u0103 \xEEncarci un fi\u0219ier mai mic.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "Te rug\u0103m s\u0103 \xEEncarci {maxItems} fi\u0219iere sau mai pu\u021Bine.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "Te rug\u0103m s\u0103 \xEEncarci cel pu\u021Bin {minItems} fi\u0219ier(e).",
  "df.wise.PersistAsyncSchema.genericError": "Ceva nu a mers bine, te rug\u0103m s\u0103 \xEEncerci din nou.",
  "df.wise.SearchLayout.loading": "Se \xEEncarc\u0103..."
};

// src/i18n/ru.json
var ru_default = {
  "df.wise.ArraySchema.addItem": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "df.wise.ArraySchema.addItemTitle": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442",
  "df.wise.ArraySchema.editItem": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "df.wise.ArraySchema.maxItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 {maxItems} \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "df.wise.ArraySchema.minItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minItems}.",
  "df.wise.ArraySchema.removeItem": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
  "df.wise.ControlFeedback.maxLength": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 {maxLength} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "df.wise.ControlFeedback.maximum": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E, \u0440\u0430\u0432\u043D\u043E\u0435 {maximum} \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435.",
  "df.wise.ControlFeedback.maximumDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443, \u0440\u0430\u0432\u043D\u0443\u044E {maximum} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0440\u0430\u043D\u043D\u044E\u044E.",
  "df.wise.ControlFeedback.minLength": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minLength} \u0441\u0438\u043C\u0432\u043E\u043B\u0430(-\u043E\u0432).",
  "df.wise.ControlFeedback.minimum": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E, \u0440\u0430\u0432\u043D\u043E\u0435 {minimum} \u0438\u043B\u0438 \u0431\u043E\u043B\u044C\u0448\u0435.",
  "df.wise.ControlFeedback.minimumDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443, \u0440\u0430\u0432\u043D\u0443\u044E {minimum} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0437\u0434\u043D\u044E\u044E.",
  "df.wise.ControlFeedback.pattern": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u044D\u0442\u043E \u0432 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435.",
  "df.wise.ControlFeedback.patternDate": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0432 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435.",
  "df.wise.ControlFeedback.required": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435.",
  "df.wise.ControlFeedback.type": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0442\u0438\u043F",
  "df.wise.DynamicParagraph.copied": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
  "df.wise.DynamicParagraph.copy": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
  "df.wise.ErrorBoundary.errorAlert": "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A.",
  "df.wise.ErrorBoundary.retry": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
  "df.wise.ExternalConfirmation.cancel": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
  "df.wise.ExternalConfirmation.description": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C **{origin}** \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
  "df.wise.ExternalConfirmation.open": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
  "df.wise.ExternalConfirmation.title": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435",
  "df.wise.Help.ariaLabel": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
  "df.wise.MultiSelect.summary": "{first} \u0438 \u0435\u0449\u0435 {count} \u0434\u0440\u0443\u0433\u0438\u0445",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0444\u0430\u0439\u043B \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0439. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u043C\u0435\u043D\u044C\u0448\u0435\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 {maxItems} \u0444\u0430\u0439\u043B\u043E\u0432.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 {minItems} \u0444\u0430\u0439\u043B(-\u0430/\u043E\u0432).",
  "df.wise.PersistAsyncSchema.genericError": "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437.",
  "df.wise.SearchLayout.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
};

// src/i18n/th.json
var th_default = {
  "df.wise.ArraySchema.addItem": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  "df.wise.ArraySchema.addItemTitle": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "df.wise.ArraySchema.editItem": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  "df.wise.ArraySchema.maxItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21 {maxItems} \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "df.wise.ArraySchema.minItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minItems}",
  "df.wise.ArraySchema.removeItem": "\u0E25\u0E1A",
  "df.wise.ControlFeedback.maxLength": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19 {maxLength} \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "df.wise.ControlFeedback.maximum": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 {maximum} \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "df.wise.ControlFeedback.maximumDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E23\u0E07\u0E1E\u0E2D\u0E14\u0E35\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E48\u0E2D\u0E19 {maximum}",
  "df.wise.ControlFeedback.minLength": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minLength} \u0E15\u0E31\u0E27",
  "df.wise.ControlFeedback.minimum": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 {minimum} \u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32",
  "df.wise.ControlFeedback.minimumDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E23\u0E07\u0E1E\u0E2D\u0E14\u0E35\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E25\u0E31\u0E07 {minimum}",
  "df.wise.ControlFeedback.pattern": "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "df.wise.ControlFeedback.patternDate": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "df.wise.ControlFeedback.required": "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49",
  "df.wise.ControlFeedback.type": "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
  "df.wise.DynamicParagraph.copied": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14",
  "df.wise.DynamicParagraph.copy": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
  "df.wise.ErrorBoundary.errorAlert": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19",
  "df.wise.ErrorBoundary.retry": "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "df.wise.ExternalConfirmation.cancel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  "df.wise.ExternalConfirmation.description": "\u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14 **{origin}** \u0E40\u0E1B\u0E47\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
  "df.wise.ExternalConfirmation.open": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48",
  "df.wise.ExternalConfirmation.title": "\u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
  "df.wise.Help.ariaLabel": "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
  "df.wise.MultiSelect.summary": "{first} \u0E41\u0E25\u0E30\u0E2D\u0E35\u0E01 {count}",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E44\u0E1F\u0E25\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E0D\u0E48\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01\u0E25\u0E07",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14 {maxItems} \u0E44\u0E1F\u0E25\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "df.wise.MultipleFileUploadSchema.minItemsError": "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {minItems} \u0E44\u0E1F\u0E25\u0E4C",
  "df.wise.PersistAsyncSchema.genericError": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
  "df.wise.SearchLayout.loading": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14..."
};

// src/i18n/tr.json
var tr_default = {
  "df.wise.ArraySchema.addItem": "Kaydet",
  "df.wise.ArraySchema.addItemTitle": "\xD6ge ekle",
  "df.wise.ArraySchema.editItem": "Kaydet",
  "df.wise.ArraySchema.maxItemsError": "L\xFCtfen {maxItems} veya daha az ekleme yap\u0131n",
  "df.wise.ArraySchema.minItemsError": "L\xFCtfen en az {minItems} ekleme yap\u0131n.",
  "df.wise.ArraySchema.removeItem": "Kald\u0131r",
  "df.wise.ControlFeedback.maxLength": "L\xFCtfen {maxLength} veya daha az karakter girin.",
  "df.wise.ControlFeedback.maximum": "L\xFCtfen {maximum} veya daha d\xFC\u015F\xFCk bir say\u0131 girin.",
  "df.wise.ControlFeedback.maximumDate": "L\xFCtfen {maximum} veya daha erken bir tarih girin.",
  "df.wise.ControlFeedback.minLength": "En az {minLength} karakter girebilirsiniz.",
  "df.wise.ControlFeedback.minimum": "L\xFCtfen {minimum} veya daha y\xFCksek bir say\u0131 girin.",
  "df.wise.ControlFeedback.minimumDate": "L\xFCtfen {minimum} veya daha ge\xE7 bir tarih girin.",
  "df.wise.ControlFeedback.pattern": "Yanl\u0131\u015F bi\xE7im",
  "df.wise.ControlFeedback.patternDate": "L\xFCtfen tarihi do\u011Fru bi\xE7imde girin.",
  "df.wise.ControlFeedback.required": "L\xFCtfen bu alan\u0131 doldurun.",
  "df.wise.ControlFeedback.type": "Ge\xE7ersiz se\xE7im",
  "df.wise.DynamicParagraph.copied": "Panoya kopyaland\u0131",
  "df.wise.DynamicParagraph.copy": "Kopyala",
  "df.wise.ErrorBoundary.errorAlert": "Bir sorun olu\u015Ftu.",
  "df.wise.ErrorBoundary.retry": "Tekrar dene",
  "df.wise.ExternalConfirmation.cancel": "\u0130ptal edin",
  "df.wise.ExternalConfirmation.description": "L\xFCtfen yeni bir taray\u0131c\u0131 sekmesinde **{origin}** a\xE7mak istedi\u011Finizi onaylay\u0131n.",
  "df.wise.ExternalConfirmation.open": "Yeni sekmede a\xE7",
  "df.wise.ExternalConfirmation.title": "L\xFCtfen onaylay\u0131n",
  "df.wise.Help.ariaLabel": "Ayr\u0131nt\u0131lar i\xE7in t\u0131klay\u0131n.",
  "df.wise.MultiSelect.summary": "{first} ve {count} daha",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\xDCzg\xFCn\xFCz, bu dosya \xE7ok b\xFCy\xFCk. L\xFCtfen daha k\xFC\xE7\xFCk bir dosya y\xFCkleyin.",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "L\xFCtfen {maxItems} veya daha az dosya y\xFCkleyin.",
  "df.wise.MultipleFileUploadSchema.minItemsError": "L\xFCtfen en az {minItems} dosya y\xFCkleyin.",
  "df.wise.PersistAsyncSchema.genericError": "Bir \u015Feyler ters gitti, l\xFCtfen tekrar deneyin.",
  "df.wise.SearchLayout.loading": "Y\xFCkleniyor..."
};

// src/i18n/zh_CN.json
var zh_CN_default = {
  "df.wise.ArraySchema.addItem": "\u4FDD\u5B58",
  "df.wise.ArraySchema.addItemTitle": "\u6DFB\u52A0\u9879\u76EE",
  "df.wise.ArraySchema.editItem": "\u4FDD\u5B58",
  "df.wise.ArraySchema.maxItemsError": "\u8BF7\u6DFB\u52A0\u4E0D\u8D85\u8FC7 {maxItems} \u9879\u3002",
  "df.wise.ArraySchema.minItemsError": "\u8BF7\u81F3\u5C11\u6DFB\u52A0 {minItems} \u9879\u3002",
  "df.wise.ArraySchema.removeItem": "\u79FB\u9664",
  "df.wise.ControlFeedback.maxLength": "\u8BF7\u8F93\u5165\u4E0D\u8D85\u8FC7 {maxLength} \u4E2A\u5B57\u7B26\u3002",
  "df.wise.ControlFeedback.maximum": "\u8BF7\u8F93\u5165\u4E00\u4E2A\u5C0F\u4E8E\u6216\u7B49\u4E8E {maximum} \u7684\u6570\u5B57\u3002",
  "df.wise.ControlFeedback.maximumDate": "\u8BF7\u8F93\u5165 {maximum} \u6216\u4E4B\u524D\u7684\u65E5\u671F",
  "df.wise.ControlFeedback.minLength": "\u8BF7\u81F3\u5C11\u8F93\u5165 {minLength} \u4E2A\u5B57\u7B26",
  "df.wise.ControlFeedback.minimum": "\u8BF7\u8F93\u5165\u4E00\u4E2A\u5927\u4E8E\u6216\u7B49\u4E8E {minimum} \u7684\u6570\u5B57",
  "df.wise.ControlFeedback.minimumDate": "\u8BF7\u8F93\u5165 {minimum} \u6216\u4E4B\u540E\u7684\u65E5\u671F",
  "df.wise.ControlFeedback.pattern": "\u8BF7\u4EE5\u6B63\u786E\u7684\u683C\u5F0F\u8F93\u5165",
  "df.wise.ControlFeedback.patternDate": "\u8BF7\u4EE5\u6B63\u786E\u7684\u683C\u5F0F\u8F93\u5165\u65E5\u671F",
  "df.wise.ControlFeedback.required": "\u8BF7\u586B\u5199\u6B64\u5B57\u6BB5\u3002",
  "df.wise.ControlFeedback.type": "\u7C7B\u578B\u9519\u8BEF",
  "df.wise.DynamicParagraph.copied": "\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
  "df.wise.DynamicParagraph.copy": "\u590D\u5236",
  "df.wise.ErrorBoundary.errorAlert": "\u51FA\u9519\u4E86\u3002",
  "df.wise.ErrorBoundary.retry": "\u91CD\u8BD5",
  "df.wise.ExternalConfirmation.cancel": "\u53D6\u6D88",
  "df.wise.ExternalConfirmation.description": "\u8BF7\u786E\u8BA4\u60A8\u662F\u5426\u8981\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00**{origin}**\u3002",
  "df.wise.ExternalConfirmation.open": "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00",
  "df.wise.ExternalConfirmation.title": "\u8BF7\u786E\u8BA4",
  "df.wise.Help.ariaLabel": "\u70B9\u51FB\u6B64\u5904\u83B7\u53D6\u66F4\u591A\u4FE1\u606F\u3002",
  "df.wise.MultiSelect.summary": "{first} \u548C\u5176\u4ED6 {count} \u4E2A",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8BE5\u6587\u4EF6\u592A\u5927\u3002\u8BF7\u4E0A\u4F20\u4E00\u4E2A\u66F4\u5C0F\u7684\u6587\u4EF6\u3002",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "\u8BF7\u4E0A\u4F20\u4E0D\u8D85\u8FC7 {maxItems} \u4E2A\u6587\u4EF6\u3002",
  "df.wise.MultipleFileUploadSchema.minItemsError": "\u8BF7\u4E0A\u4F20\u81F3\u5C11 {minItems} \u4E2A\u6587\u4EF6\u3002",
  "df.wise.PersistAsyncSchema.genericError": "\u51FA\u9519\u4E86\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  "df.wise.SearchLayout.loading": "\u6B63\u5728\u52A0\u8F7D\u2026"
};

// src/i18n/zh_HK.json
var zh_HK_default = {
  "df.wise.ArraySchema.addItem": "\u5132\u5B58",
  "df.wise.ArraySchema.addItemTitle": "\u6DFB\u52A0\u9805\u76EE",
  "df.wise.ArraySchema.editItem": "\u5132\u5B58",
  "df.wise.ArraySchema.maxItemsError": "\u8ACB\u6DFB\u52A0\u4E0D\u8D85\u904E{maxItems}\u9805\u3002",
  "df.wise.ArraySchema.minItemsError": "\u8ACB\u81F3\u5C11\u6DFB\u52A0{minItems}\u9805\u3002",
  "df.wise.ArraySchema.removeItem": "\u79FB\u9664",
  "df.wise.ControlFeedback.maxLength": "\u8ACB\u8F38\u5165\u6700\u591A{maxLength}\u500B\u5B57\u5143\u3002",
  "df.wise.ControlFeedback.maximum": "\u8ACB\u8F38\u5165\u4E00\u500B\u5C0F\u65BC\u6216\u7B49\u65BC{maximum}\u7684\u6578\u5B57\u3002",
  "df.wise.ControlFeedback.maximumDate": "\u8ACB\u8F38\u5165{maximum}\u6216\u4E4B\u524D\u7684\u65E5\u671F\u3002",
  "df.wise.ControlFeedback.minLength": "\u8ACB\u8F38\u5165\u81F3\u5C11{minLength}\u500B\u5B57\u5143\u3002",
  "df.wise.ControlFeedback.minimum": "\u8ACB\u8F38\u5165\u4E00\u500B\u5927\u65BC\u6216\u7B49\u65BC{minimum}\u7684\u6578\u5B57\u3002",
  "df.wise.ControlFeedback.minimumDate": "\u8ACB\u8F38\u5165{minimum}\u6216\u4E4B\u5F8C\u7684\u65E5\u671F\u3002",
  "df.wise.ControlFeedback.pattern": "\u8ACB\u4EE5\u6B63\u78BA\u683C\u5F0F\u8F38\u5165\u5185\u5BB9\u3002",
  "df.wise.ControlFeedback.patternDate": "\u8ACB\u4EE5\u6B63\u78BA\u683C\u5F0F\u8F38\u5165\u65E5\u671F\u3002",
  "df.wise.ControlFeedback.required": "\u8ACB\u586B\u5BEB\u6B64\u6B04\u4F4D\u3002",
  "df.wise.ControlFeedback.type": "\u932F\u8AA4\u7684\u985E\u578B",
  "df.wise.DynamicParagraph.copied": "\u8907\u88FD\u5230\u526A\u8CBC\u677F",
  "df.wise.DynamicParagraph.copy": "\u8907\u88FD",
  "df.wise.ErrorBoundary.errorAlert": "\u51FA\u4E86\u4E9B\u554F\u984C\u3002",
  "df.wise.ErrorBoundary.retry": "\u91CD\u8A66",
  "df.wise.ExternalConfirmation.cancel": "\u53D6\u6D88",
  "df.wise.ExternalConfirmation.description": "\u8ACB\u78BA\u8A8D\u4F60\u662F\u5426\u8981\u5728\u700F\u89BD\u5668\u7684\u65B0\u5206\u9801\u6253\u958B**{origin}**\u3002",
  "df.wise.ExternalConfirmation.open": "\u5728\u65B0\u5206\u9801\u4E2D\u958B\u555F",
  "df.wise.ExternalConfirmation.title": "\u8ACB\u78BA\u8A8D",
  "df.wise.Help.ariaLabel": "\u6309\u6B64\u67E5\u770B\u8A73\u60C5\u3002",
  "df.wise.MultiSelect.summary": "{first}\u548C\u5176\u4ED6{count}\u9805",
  "df.wise.MultipleFileUploadSchema.maxFileSizeError": "\u62B1\u6B49\uFF0C\u8A72\u6A94\u6848\u592A\u5927\u3002\u8ACB\u4E0A\u8F09\u4E00\u500B\u8F03\u5C0F\u7684\u6A94\u6848\u3002",
  "df.wise.MultipleFileUploadSchema.maxItemsError": "\u8ACB\u4E0D\u8981\u4E0A\u8F09\u8D85\u904E{maxItems}\u500B\u6A94\u6848\u3002",
  "df.wise.MultipleFileUploadSchema.minItemsError": "\u8ACB\u4E0A\u8F09\u81F3\u5C11{minItems}\u500B\u6A94\u6848\u3002",
  "df.wise.PersistAsyncSchema.genericError": "\u51FA\u73FE\u4E86\u554F\u984C\uFF0C\u8ACB\u518D\u8A66\u4E00\u6B21\u3002",
  "df.wise.SearchLayout.loading": "\u8F09\u5165\u4E2D\u2026"
};

// src/i18n/index.ts
var wiseTranslations = {
  en: en_default,
  de: de_default,
  es: es_default,
  fr: fr_default,
  hu: hu_default,
  id: id_default,
  it: it_default,
  ja: ja_default,
  pl: pl_default,
  pt: pt_default,
  ro: ro_default,
  ru: ru_default,
  th: th_default,
  tr: tr_default,
  zh: zh_CN_default,
  "zh-CN": zh_CN_default,
  "zh-HK": zh_HK_default
};
var languages = Array.from(
  /* @__PURE__ */ new Set([...Object.keys(coreTranslations), ...Object.keys(wiseTranslations)])
);
var translations = languages.reduce(
  (acc, lang) => __spreadProps(__spreadValues({}, acc), { [lang]: __spreadValues(__spreadValues({}, coreTranslations[lang]), wiseTranslations[lang]) }),
  {}
);
var i18n_default = translations;

// src/dynamicFlow/DynamicFlow.tsx
import { forwardRef, useCallback, useMemo as useMemo2 } from "react";
import { useIntl as useIntl9 } from "react-intl";
import {
  DynamicFlow as DynamicFlowCoreLegacy,
  DynamicFlowCoreRevamp,
  DynamicFormCore
} from "@wise/dynamic-flow-client";

// ../renderers/src/AlertRenderer.tsx
import { Alert } from "@transferwise/components";

// ../renderers/src/utils/layout-utils.ts
var getMargin = (size) => {
  switch (size) {
    case "xs":
      return "m-b-0";
    case "sm":
      return "m-b-1";
    case "md":
      return "m-b-2";
    case "lg":
      return "m-b-3";
    case "xl":
      return "m-b-5";
    default:
      return "";
  }
};
var getTextAlignment = (align) => {
  switch (align) {
    case "end":
      return "text-xs-right";
    case "center":
      return "text-xs-center";
    case "start":
    default:
      return "";
  }
};
var getTextAlignmentAndMargin = (component) => `${getTextAlignment(component.align)} ${getMargin(component.margin)}`;

// ../renderers/src/AlertRenderer.tsx
import { jsx } from "react/jsx-runtime";
var AlertRenderer = {
  canRenderType: "alert",
  render: ({ context, markdown, margin, callToAction }) => /* @__PURE__ */ jsx(
    Alert,
    {
      type: context,
      className: getMargin(margin),
      message: markdown,
      action: mapCtaToAlertAction(callToAction)
    }
  )
};
var mapCtaToAlertAction = (callToAction) => {
  if (!callToAction) {
    return void 0;
  }
  const { accessibilityDescription, title } = callToAction;
  const sharedProps = {
    "aria-label": accessibilityDescription,
    text: title
  };
  if (callToAction.type === "link") {
    const { href } = callToAction;
    return __spreadProps(__spreadValues({}, sharedProps), {
      href,
      target: "_blank"
    });
  }
  if (callToAction.type === "action") {
    const { onClick } = callToAction;
    return __spreadProps(__spreadValues({}, sharedProps), {
      onClick
    });
  }
  return void 0;
};
var AlertRenderer_default = AlertRenderer;

// ../renderers/src/components/FieldInput.tsx
import { Field } from "@transferwise/components";

// ../renderers/src/components/Help.tsx
import { Info, Markdown } from "@transferwise/components";
import { useIntl } from "react-intl";

// ../renderers/src/messages/help.messages.ts
import { defineMessages } from "react-intl";
var help_messages_default = defineMessages({
  helpAria: {
    id: "df.wise.Help.ariaLabel",
    defaultMessage: "Click here for more info.",
    description: "Aria label for help."
  }
});

// ../renderers/src/components/Help.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function Help({ help }) {
  const intl = useIntl();
  return /* @__PURE__ */ jsx2(
    Info,
    {
      className: "m-l-1",
      content: /* @__PURE__ */ jsx2(Markdown, { config: { link: { target: "_blank" } }, children: help }),
      presentation: "POPOVER",
      size: "sm",
      "aria-label": intl.formatMessage(help_messages_default.helpAria)
    }
  );
}
var Help_default = Help;

// ../renderers/src/components/LabelContentWithHelp.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
function LabelContentWithHelp({ text, help }) {
  return /* @__PURE__ */ jsxs("div", { children: [
    text,
    /* @__PURE__ */ jsx3(Help_default, { help })
  ] });
}

// ../renderers/src/components/FieldInput.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
function FieldInput({ id, children, label, validation, description, help }) {
  const labelContent = label && help ? /* @__PURE__ */ jsx4(LabelContentWithHelp, { text: label, help }) : label;
  return /* @__PURE__ */ jsx4(
    Field,
    {
      id,
      label: labelContent,
      description,
      message: validation == null ? void 0 : validation.message,
      sentiment: mapStatusToSentiment(validation),
      children
    }
  );
}
var mapStatusToSentiment = (validation) => {
  if (validation) {
    if (validation.status === "valid") {
      return "positive";
    }
    return "negative";
  }
  return void 0;
};
var FieldInput_default = FieldInput;

// ../renderers/src/CheckboxInputRenderer.tsx
import { Checkbox } from "@transferwise/components";
import { jsx as jsx5 } from "react/jsx-runtime";
var CheckboxInputRenderer = {
  canRenderType: "input-checkbox",
  render: (props) => {
    const _a = props, {
      id,
      control,
      title = "",
      description,
      help,
      type,
      validationState,
      value
    } = _a, rest = __objRest(_a, [
      "id",
      "control",
      "title",
      "description",
      "help",
      "type",
      "validationState",
      "value"
    ]);
    const checkboxProps = __spreadProps(__spreadValues({}, rest), { label: title, secondary: description, checked: value });
    return /* @__PURE__ */ jsx5(FieldInput_default, { id, label: "", description: "", validation: validationState, help, children: /* @__PURE__ */ jsx5(Checkbox, __spreadValues({ id }, checkboxProps)) });
  }
};
var CheckboxInputRenderer_default = CheckboxInputRenderer;

// ../renderers/src/BoxRenderer.tsx
import classNames from "classnames";
import { jsx as jsx6 } from "react/jsx-runtime";
var BoxRenderer = {
  canRenderType: "box",
  render: ({ children, control, margin, width }) => {
    const hasFixedWidth = width !== "xl";
    const hasBorder = control === "bordered" || control === "bordered-web";
    const contents = /* @__PURE__ */ jsx6(
      "div",
      {
        className: classNames({
          "df-box-renderer-border": hasBorder,
          [`df-box-renderer-width-${width}`]: hasFixedWidth,
          [getMargin(margin)]: !hasFixedWidth
        }),
        children
      }
    );
    return hasFixedWidth ? /* @__PURE__ */ jsx6("div", { className: classNames("df-box-renderer-fixed-width", getMargin(margin)), children: contents }) : contents;
  }
};
var BoxRenderer_default = BoxRenderer;

// ../renderers/src/ButtonRenderer.tsx
import { Button } from "@transferwise/components";
import { jsx as jsx7 } from "react/jsx-runtime";
var ButtonRenderer = {
  canRenderType: "button",
  render: ({ control, context, disabled, margin, title, size, onClick }) => {
    const priority = mapControl(control);
    const type = priority === "tertiary" ? void 0 : mapContext(context);
    return /* @__PURE__ */ jsx7(
      Button,
      {
        block: true,
        className: getMargin(margin),
        disabled,
        priority,
        size: mapSize(size),
        type,
        onClick,
        children: title
      }
    );
  }
};
var mapContext = (context) => {
  switch (context) {
    case "neutral":
    case "warning":
      return "accent";
    default:
      return context;
  }
};
var mapControl = (control) => {
  switch (control) {
    case "primary":
    case "tertiary":
      return control;
    default:
      return "secondary";
  }
};
var mapSize = (size) => {
  if (!size) {
    return void 0;
  }
  switch (size) {
    case "xs":
    case "sm":
      return "sm";
    case "lg":
    case "xl":
      return "lg";
    case "md":
    default:
      return "md";
  }
};
var ButtonRenderer_default = ButtonRenderer;

// ../renderers/src/ColumnsRenderer.tsx
import classNames2 from "classnames";
import { jsx as jsx8, jsxs as jsxs2 } from "react/jsx-runtime";
var ColumnsRenderer = {
  canRenderType: "columns",
  render: ({ bias, margin, startChildren, endChildren }) => /* @__PURE__ */ jsxs2(
    "div",
    {
      className: classNames2("df-columns-renderer-container", getMargin(margin), {
        "df-columns-renderer-bias-start": bias === "start",
        "df-columns-renderer-bias-end": bias === "end"
      }),
      children: [
        /* @__PURE__ */ jsx8("div", { className: "df-columns-renderer-column", children: startChildren }),
        /* @__PURE__ */ jsx8("div", { className: "df-columns-renderer-column", children: endChildren })
      ]
    }
  )
};
var ColumnsRenderer_default = ColumnsRenderer;

// ../renderers/src/components/VariableDateInput.tsx
import { DateInput, DateLookup } from "@transferwise/components";

// ../renderers/src/validators/type-validators.ts
var isNumber = (value) => typeof value === "number" && !Number.isNaN(value);

// ../renderers/src/utils/value-utils.ts
var numericValueOrNull = (newValue) => /^\d+$/.test(newValue) && !Number.isNaN(Number.parseFloat(newValue)) ? newValue : null;
var dateStringToDateOrNull = (dateString) => {
  if (!dateString) {
    return null;
  }
  const [year, month, date] = dateString.split("-").map((number) => Number.parseInt(number, 10));
  if (!isNumber(year) || !isNumber(month) || !isNumber(date)) {
    return null;
  }
  return new Date(year, month - 1, date);
};
var dateToDateString = (date) => {
  const d = new Date(date);
  const month = String(d.getMonth() + 1);
  const day = String(d.getDate());
  const year = d.getFullYear();
  const formattedMonth = month.length < 2 ? `0${month}` : month;
  const formattedDay = day.length < 2 ? `0${day}` : day;
  return [year, formattedMonth, formattedDay].join("-");
};

// ../renderers/src/components/VariableDateInput.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
function VariableDateInput({
  control,
  inputProps
}) {
  const {
    autoComplete,
    minimumDate,
    maximumDate,
    placeholder,
    disabled,
    onBlur,
    onChange,
    onFocus
  } = inputProps;
  if (control === "date-lookup") {
    return /* @__PURE__ */ jsx9(
      DateLookup,
      {
        value: dateStringToDateOrNull(inputProps.value),
        min: dateStringToDateOrNull(minimumDate),
        max: dateStringToDateOrNull(maximumDate),
        placeholder,
        disabled,
        onChange: (date) => {
          onChange(date !== null ? dateToDateString(date) : null);
        },
        onBlur,
        onFocus
      }
    );
  }
  return /* @__PURE__ */ jsx9(
    DateInput,
    __spreadProps(__spreadValues({}, inputProps), {
      dayAutoComplete: getAutocompleteString(autoComplete, "day"),
      yearAutoComplete: getAutocompleteString(autoComplete, "year")
    })
  );
}
var getAutocompleteString = (value, suffix) => {
  if (value === "bday") {
    return `${value}-${suffix}`;
  }
  return void 0;
};
var VariableDateInput_default = VariableDateInput;

// ../renderers/src/DateInputRenderer.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var DateInputRenderer = {
  canRenderType: "input-date",
  render: (props) => {
    const _a = props, {
      id,
      control,
      description,
      type,
      help,
      title,
      validationState,
      value: initialValue
    } = _a, rest = __objRest(_a, [
      "id",
      "control",
      "description",
      "type",
      "help",
      "title",
      "validationState",
      "value"
    ]);
    const value = initialValue != null ? initialValue : "";
    const inputProps = __spreadProps(__spreadValues({}, rest), { value, id });
    return /* @__PURE__ */ jsx10(
      FieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx10(VariableDateInput_default, { control, inputProps })
      }
    );
  }
};
var DateInputRenderer_default = DateInputRenderer;

// ../renderers/src/DecisionRenderer.tsx
import { Header, NavigationOption, NavigationOptionsList } from "@transferwise/components";

// ../renderers/src/components/OptionMedia.tsx
import { AvatarView as AvatarView2 } from "@transferwise/components";

// ../renderers/src/utils/image-utils.tsx
import { AvatarView } from "@transferwise/components";

// ../renderers/src/components/icon/FlagIcon.tsx
import { Flag } from "@wise/art";
import { jsx as jsx11 } from "react/jsx-runtime";
var isFlagIcon = (name) => name.startsWith("flag-");
function FlagIcon({ name }) {
  if (!isFlagIcon(name)) {
    return null;
  }
  const code = name.substring(5);
  return /* @__PURE__ */ jsx11(Flag, { code });
}

// ../renderers/src/components/icon/NamedIcon.tsx
import * as icons from "@transferwise/icons";
import { jsx as jsx12 } from "react/jsx-runtime";
var isNamedIcon = (name) => {
  const iconName = toCapitalisedCamelCase(name);
  return Object.keys(icons).includes(iconName);
};
function NamedIcon({ name }) {
  if (!isNamedIcon(name)) {
    return null;
  }
  const iconName = toCapitalisedCamelCase(name);
  const Icon = icons[iconName];
  return /* @__PURE__ */ jsx12(Icon, { size: 24 });
}
var toCapitalisedCamelCase = (value) => value.split("-").map(capitaliseFirstChar).join("");
var capitaliseFirstChar = (value) => `${value[0].toUpperCase()}${value.slice(1)}`;

// ../renderers/src/components/icon/DynamicIcon.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
function DynamicIcon({ name }) {
  if (isFlagIcon(name)) {
    return /* @__PURE__ */ jsx13(FlagIcon, { name });
  }
  if (isNamedIcon(name)) {
    return /* @__PURE__ */ jsx13(NamedIcon, { name });
  }
  return null;
}
var DynamicIcon_default = DynamicIcon;

// ../renderers/src/utils/UrnFlag.tsx
import { Flag as Flag2 } from "@wise/art";
import { jsx as jsx14 } from "react/jsx-runtime";
var countryUrnPrefix = "urn:wise:countries:";
var currencyUrnPrefix = "urn:wise:currencies:";
var isUrnFlag = (uri) => uri.startsWith(countryUrnPrefix) || uri.startsWith(currencyUrnPrefix);
function UrnFlag({ size, urn }) {
  return /* @__PURE__ */ jsx14(Flag2, { code: getCode(urn), intrinsicSize: size });
}
var getCode = (urn) => {
  return urn.replace(countryUrnPrefix, "").replace(currencyUrnPrefix, "").replace(":image", "").split("?")[0];
};

// ../renderers/src/utils/image-utils.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var getBadgedMedia = (iconNode, imageNode, size) => {
  if (iconNode && imageNode) {
    if (imageNode && iconNode) {
      return /* @__PURE__ */ jsx15(AvatarView, { size, badge: { asset: iconNode }, children: imageNode });
    }
  }
  return null;
};
var getIconNode = (icon) => {
  if (icon) {
    if ("name" in icon) {
      return /* @__PURE__ */ jsx15(DynamicIcon_default, { name: icon.name });
    }
    if (icon.text) {
      return icon.text;
    }
  }
  return null;
};
var getImageNode = (image, size) => {
  if (image) {
    const { accessibilityDescription, uri } = image;
    if (!uri.startsWith("urn:")) {
      return /* @__PURE__ */ jsx15("img", { src: uri, alt: accessibilityDescription, width: `${size}px` });
    }
    if (isUrnFlag(uri)) {
      return /* @__PURE__ */ jsx15(UrnFlag, { urn: uri, accessibilityDescription, size });
    }
  }
  return null;
};

// ../renderers/src/components/OptionMedia.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var mediaSize = 64;
var badgeMediaSize = 48;
function OptionMedia({
  icon,
  image,
  preferAvatar
}) {
  const imageNode = getImageNode(image, mediaSize);
  const iconNode = getIconNode(icon);
  const badge = getBadgedMedia(iconNode, imageNode, badgeMediaSize);
  if (badge) {
    return badge;
  }
  if (imageNode) {
    return preferAvatar ? /* @__PURE__ */ jsx16(AvatarView2, { children: imageNode }) : imageNode;
  }
  if (iconNode) {
    return /* @__PURE__ */ jsx16(AvatarView2, { children: iconNode });
  }
}

// ../renderers/src/DecisionRenderer.tsx
import { jsx as jsx17, jsxs as jsxs3 } from "react/jsx-runtime";
var DecisionRenderer = {
  canRenderType: "decision",
  render: ({ control, margin, options, title }) => /* @__PURE__ */ jsxs3("div", { className: getMargin(margin), children: [
    title && /* @__PURE__ */ jsx17(Header, { as: "h2", title }),
    /* @__PURE__ */ jsx17(NavigationOptionsList, { children: options.map((option) => {
      const { description, disabled, icon, image, title: itemTitle, onClick } = option;
      return /* @__PURE__ */ jsx17(
        NavigationOption,
        {
          title: itemTitle,
          content: description,
          disabled,
          media: /* @__PURE__ */ jsx17(OptionMedia, { icon, image, preferAvatar: control === "with-avatar" }),
          showMediaCircle: false,
          showMediaAtAllSizes: true,
          onClick
        },
        JSON.stringify(option)
      );
    }) })
  ] })
};
var DecisionRenderer_default = DecisionRenderer;

// ../renderers/src/DividerRenderer.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var DividerRenderer = {
  canRenderType: "divider",
  render: ({ margin }) => /* @__PURE__ */ jsx18("hr", { className: `m-t-0 ${getMargin(margin)}` })
};
var DividerRenderer_default = DividerRenderer;

// ../renderers/src/FormRenderer.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var FormRenderer = {
  canRenderType: "form",
  render: ({ children, margin }) => /* @__PURE__ */ jsx19("div", { className: getMargin(margin), children })
};
var FormRenderer_default = FormRenderer;

// ../renderers/src/FormSectionRenderer.tsx
import { Header as Header2 } from "@transferwise/components";
import { jsx as jsx20, jsxs as jsxs4 } from "react/jsx-runtime";
var FormSectionRenderer = {
  canRenderType: "section",
  render: ({ title, description, children }) => /* @__PURE__ */ jsxs4("fieldset", { children: [
    title && /* @__PURE__ */ jsx20(
      Header2,
      {
        as: "h2",
        title
      }
    ),
    description && /* @__PURE__ */ jsx20("p", { children: description }),
    children
  ] })
};
var FormSectionRenderer_default = FormSectionRenderer;

// ../renderers/src/HeadingRenderer.tsx
import { Display } from "@transferwise/components";
import { jsx as jsx21 } from "react/jsx-runtime";
var HeadingRenderer = {
  canRenderType: "heading",
  render: (props) => /* @__PURE__ */ jsx21(Heading, __spreadValues({}, props))
};
function Heading(props) {
  const { text, size, align, margin, control } = props;
  const className = getTextAlignmentAndMargin({ align, margin });
  return control === "display" ? /* @__PURE__ */ jsx21(DisplayHeading, { size, text, className }) : /* @__PURE__ */ jsx21(StandardHeading, { size, text, className });
}
function DisplayHeading({ size, text, className }) {
  return /* @__PURE__ */ jsx21(Display, { type: getDisplayType(size), className, children: text });
}
function StandardHeading({ size, text, className }) {
  switch (size) {
    case "xs":
      return /* @__PURE__ */ jsx21("h5", { className, children: text });
    case "sm":
      return /* @__PURE__ */ jsx21("h4", { className, children: text });
    case "lg":
      return /* @__PURE__ */ jsx21("h2", { className, children: text });
    case "xl":
      return /* @__PURE__ */ jsx21("h1", { className, children: text });
    case "md":
    default:
      return /* @__PURE__ */ jsx21("h3", { className, children: text });
  }
}
var getDisplayType = (size) => {
  switch (size) {
    case "xs":
    case "sm":
      return "display-small";
    case "xl":
    case "lg":
      return "display-large";
    case "md":
    default:
      return "display-medium";
  }
};
var HeadingRenderer_default = HeadingRenderer;

// ../renderers/src/ImageRenderer/UrlImage.tsx
import { Image } from "@transferwise/components";
import { useEffect, useState } from "react";

// ../renderers/src/utils/api-utils.ts
function isRelativePath(url = "") {
  return !["https://", "http://", "data:"].some(
    (prefix) => url.startsWith(prefix) && url.length > prefix.length
  );
}

// ../renderers/src/ImageRenderer/UrlImage.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function UrlImage({
  accessibilityDescription,
  align,
  margin,
  size,
  uri,
  httpClient
}) {
  const [imageSource, setImageSource] = useState("");
  useEffect(() => {
    if (!uri.startsWith("urn:")) {
      void getImageSource(httpClient, uri).then(setImageSource);
    }
  }, [uri, httpClient]);
  return /* @__PURE__ */ jsx22("div", { className: `df-image ${align} ${size || "md"}`, children: /* @__PURE__ */ jsx22(
    Image,
    {
      className: `img-responsive ${getMargin(margin)}`,
      alt: accessibilityDescription != null ? accessibilityDescription : "",
      src: imageSource,
      stretch: true,
      shrink: true
    }
  ) });
}
var readImageBlobAsDataURL = async (imageBlob) => (
  // we can safely assume the type of reader.result is string
  // because we're calling reader.readAsDataURL
  // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/result
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("loadend", () => resolve(reader.result));
    reader.addEventListener("error", reject);
    reader.readAsDataURL(imageBlob);
  })
);
var getImageSource = async (httpClient, imageUrl) => {
  var _a;
  try {
    if (isRelativePath(imageUrl) || (imageUrl == null ? void 0 : imageUrl.startsWith(`${(_a = window == null ? void 0 : window.location) == null ? void 0 : _a.origin}/`))) {
      return await httpClient(imageUrl, {
        method: "GET",
        headers: { "Content-Type": "image/image" },
        credentials: "same-origin"
      }).then(async (response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Image fetching failed");
      }).then(readImageBlobAsDataURL).catch(() => imageUrl);
    }
    return imageUrl;
  } catch (e) {
    return imageUrl;
  }
};

// ../renderers/src/ImageRenderer/UrnFlagImage.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var maxFlagSize = 600;
function UrnFlagImage({
  accessibilityDescription,
  align,
  margin,
  size,
  uri
}) {
  return /* @__PURE__ */ jsx23("div", { className: `df-image ${align} ${size || "md"} ${getMargin(margin)}`, children: /* @__PURE__ */ jsx23(UrnFlag, { size: maxFlagSize, urn: uri, accessibilityDescription }) });
}

// ../renderers/src/ImageRenderer/UrnIllustration.tsx
import {
  Illustration,
  Illustration3D,
  isIllustrationSupport3D
} from "@wise/art";

// ../renderers/src/ImageRenderer/isAnimated.ts
var isAnimated = (uri) => {
  const sections = uri.split("?");
  if (sections.length === 1) {
    return false;
  }
  const params = sections[1];
  if (!params.startsWith("+")) {
    return false;
  }
  return params.substring(1).split("&").some((param) => param === "type=animated");
};

// ../renderers/src/ImageRenderer/UrnIllustration.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var urnPrefix = "urn:wise:illustrations:";
var isUrnIllustration = (uri) => uri.startsWith(urnPrefix);
function UrnIllustration({
  accessibilityDescription,
  align,
  margin,
  size,
  uri
}) {
  const illustrationSize = getIllustrationSize(size);
  const illustrationName = getIllustrationName(uri);
  const illustration3DName = getIllustration3DName(uri);
  if (illustration3DName && isAnimated(uri)) {
    return /* @__PURE__ */ jsx24("div", { className: `df-image ${align} ${getMargin(margin)}`, children: /* @__PURE__ */ jsx24(Illustration3D, { name: illustration3DName, size: illustrationSize }) });
  }
  return /* @__PURE__ */ jsx24("div", { className: `df-image ${align} ${getMargin(margin)}`, children: /* @__PURE__ */ jsx24(
    Illustration,
    {
      className: "df-illustration",
      name: illustrationName,
      size: illustrationSize,
      alt: accessibilityDescription
    }
  ) });
}
var getIllustrationSize = (size) => ({ xs: "small", sm: "small", md: "medium", lg: "large", xl: "large" })[size] || "medium";
var getIllustrationName = (uri) => {
  return uri.replace(urnPrefix, "").split("?")[0];
};
var getIllustration3DName = (uri) => {
  const illustrationName = getIllustrationName(uri);
  return isIllustrationSupport3D(illustrationName) ? illustrationName : null;
};

// ../renderers/src/ImageRenderer/UrnImage.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var isUrnImage = (uri) => uri.startsWith("urn:");
function UrnImage(props) {
  const { uri } = props;
  if (isUrnIllustration(uri)) {
    return /* @__PURE__ */ jsx25(UrnIllustration, __spreadValues({}, props));
  }
  if (isUrnFlag(uri)) {
    return /* @__PURE__ */ jsx25(UrnFlagImage, __spreadValues({}, props));
  }
  return null;
}

// ../renderers/src/ImageRenderer/ImageRenderer.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var ImageRenderer = {
  canRenderType: "image",
  render: (props) => isUrnImage(props.uri) ? /* @__PURE__ */ jsx26(UrnImage, __spreadValues({}, props)) : /* @__PURE__ */ jsx26(UrlImage, __spreadValues({}, props))
};

// ../renderers/src/ImageRenderer/index.tsx
var ImageRenderer_default = ImageRenderer;

// ../renderers/src/InstructionsRenderer.tsx
import { Header as Header3, InstructionsList } from "@transferwise/components";
import { jsx as jsx27, jsxs as jsxs5 } from "react/jsx-runtime";
var doContext = ["positive", "neutral"];
var dontContext = ["warning", "negative"];
var InstructionsRenderer = {
  canRenderType: "instructions",
  render: ({ items, margin, title }) => {
    const dos = items.filter((item) => doContext.includes(item.context)).map(({ text }) => text);
    const donts = items.filter((item) => dontContext.includes(item.context)).map(({ text }) => text);
    return /* @__PURE__ */ jsxs5("div", { className: getMargin(margin), children: [
      title ? /* @__PURE__ */ jsx27(Header3, { title }) : null,
      /* @__PURE__ */ jsx27(InstructionsList, { dos, donts })
    ] });
  }
};
var InstructionsRenderer_default = InstructionsRenderer;

// ../renderers/src/IntegerInputRenderer.tsx
import { Input, InputGroup } from "@transferwise/components";

// ../renderers/src/utils/input-utils.ts
var onWheel = (event) => {
  if (event.target instanceof HTMLElement) {
    event.target.blur();
  }
};

// ../renderers/src/utils/getInlineAvatar.tsx
import { AvatarView as AvatarView3 } from "@transferwise/components";
import { jsx as jsx28 } from "react/jsx-runtime";
var mediaSize2 = 24;
function getInlineAvatar({ icon, image }) {
  const imageNode = getImageNode(image, mediaSize2);
  const iconNode = getIconNode(icon);
  const badge = getBadgedMedia(iconNode, imageNode, mediaSize2);
  if (badge) {
    return badge;
  }
  if (imageNode) {
    return imageNode;
  }
  if (isNamedIcon2(icon) && !isFlagIcon2(icon)) {
    return iconNode;
  }
  if (iconNode) {
    return /* @__PURE__ */ jsx28(AvatarView3, { size: mediaSize2, children: iconNode });
  }
  return null;
}
var isNamedIcon2 = (icon) => icon ? "name" in icon : false;
var isFlagIcon2 = (icon) => isNamedIcon2(icon) && icon.name.startsWith("flag-");

// ../renderers/src/utils/getInputGroupAddonStart.tsx
var getInputGroupAddonStart = ({ icon, image }) => {
  const content = getInlineAvatar({ icon, image });
  return content ? { content } : void 0;
};

// ../renderers/src/utils/pick.ts
function pick(obj, ...keys) {
  const result = {};
  keys.forEach((key) => {
    result[key] = obj[key];
  });
  return result;
}

// ../renderers/src/IntegerInputRenderer.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var IntegerInputRenderer = {
  canRenderType: "input-integer",
  render: (props) => {
    const { id, title, description, help, icon, image, validationState, value, onChange } = props;
    const commonProps = pick(
      props,
      "autoComplete",
      "disabled",
      "onBlur",
      "onFocus",
      "placeholder",
      "maximum",
      "minimum"
    );
    return /* @__PURE__ */ jsx29(
      FieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx29(InputGroup, { addonStart: getInputGroupAddonStart({ icon, image }), children: /* @__PURE__ */ jsx29(
          Input,
          __spreadValues({
            id,
            name: id,
            type: "number",
            step: "1",
            pattern: "\\d+",
            value: value != null ? value : "",
            onChange: ({ target: { value: newValue } }) => {
              const parsedValue = Number.parseInt(newValue, 10);
              onChange(Number.isNaN(parsedValue) ? null : parsedValue);
            },
            onWheel
          }, commonProps)
        ) })
      }
    );
  }
};
var IntegerInputRenderer_default = IntegerInputRenderer;

// ../renderers/src/LoadingIndicatorRenderer.tsx
import { Loader } from "@transferwise/components";
import { jsx as jsx30 } from "react/jsx-runtime";
var LoadingIndicatorRenderer = {
  canRenderType: "loading-indicator",
  render: ({ margin, size }) => /* @__PURE__ */ jsx30(
    Loader,
    {
      size,
      classNames: { "tw-loader": `tw-loader m-x-auto ${getMargin(margin)}` },
      "data-testid": "loading-indicator"
    }
  )
};
var LoadingIndicatorRenderer_default = LoadingIndicatorRenderer;

// ../renderers/src/MarkdownRenderer.tsx
import { Markdown as Markdown2 } from "@transferwise/components";
import { jsx as jsx31 } from "react/jsx-runtime";
var MarkdownRenderer = {
  canRenderType: "markdown",
  render: ({ content, align, margin }) => /* @__PURE__ */ jsx31("div", { className: getTextAlignmentAndMargin({ align, margin }), children: /* @__PURE__ */ jsx31(Markdown2, { config: { link: { target: "_blank" } }, children: content }) })
};
var MarkdownRenderer_default = MarkdownRenderer;

// ../renderers/src/ModalRenderer.tsx
import { Button as Button2, Modal } from "@transferwise/components";
import { useState as useState2 } from "react";
import { jsx as jsx32, jsxs as jsxs6 } from "react/jsx-runtime";
var ModalRenderer = {
  canRenderType: "modal",
  render: (props) => /* @__PURE__ */ jsx32(DFModal, __spreadValues({}, props))
};
var ModalRenderer_default = ModalRenderer;
function DFModal({ content, margin, trigger }) {
  const [visible, setVisible] = useState2(false);
  const { children, title } = content;
  return /* @__PURE__ */ jsxs6("div", { className: getMargin(margin), children: [
    /* @__PURE__ */ jsx32(Button2, { priority: "tertiary", block: true, onClick: () => setVisible(true), children: trigger.title }),
    /* @__PURE__ */ jsx32(
      Modal,
      {
        scroll: "content",
        open: visible,
        size: "lg",
        title,
        body: children,
        onClose: () => setVisible(false)
      }
    )
  ] });
}

// ../renderers/src/MultiSelectInputRenderer.tsx
import { SelectInput, SelectInputOptionContent } from "@transferwise/components";
import { useState as useState3 } from "react";
import { useIntl as useIntl2 } from "react-intl";

// ../renderers/src/messages/multi-select.messages.ts
import { defineMessages as defineMessages2 } from "react-intl";
var multi_select_messages_default = defineMessages2({
  summary: {
    id: "df.wise.MultiSelect.summary",
    defaultMessage: "{first} and {count} more",
    description: "A summary of the multiple items selected. Showing the title of the first selected item, and the number of other items that have been selected."
  }
});

// ../renderers/src/MultiSelectInputRenderer.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var MultiSelectInputRenderer = {
  canRenderType: "input-multi-select",
  render: (props) => /* @__PURE__ */ jsx33(MultiSelectInputRendererComponent, __spreadValues({}, props))
};
function MultiSelectInputRendererComponent(props) {
  const { formatMessage } = useIntl2();
  const [stagedIndices, setStagedIndices] = useState3();
  const {
    id,
    autoComplete,
    description,
    disabled,
    help,
    options,
    placeholder,
    selectedIndices,
    title,
    validationState,
    onSelect
  } = props;
  const mergedIndices = stagedIndices != null ? stagedIndices : selectedIndices;
  const getFormattedMessage = () => {
    if (mergedIndices.length > 0) {
      if (mergedIndices.length > 1) {
        return formatMessage(multi_select_messages_default.summary, {
          first: options[mergedIndices[0]].title,
          count: mergedIndices.length - 1
        });
      }
      return options[mergedIndices[0]].title;
    }
    return void 0;
  };
  const renderValue = (index, withinTrigger) => {
    const option = index >= 0 ? options[index] : null;
    if (option === null) {
      return null;
    }
    if (withinTrigger) {
      return index === mergedIndices[0] ? getFormattedMessage() : void 0;
    }
    const contentProps = {
      title: option.title,
      description: option.description,
      icon: /* @__PURE__ */ jsx33(OptionMedia, { icon: option.icon, image: option.image, preferAvatar: false })
    };
    return /* @__PURE__ */ jsx33(SelectInputOptionContent, __spreadValues({}, contentProps));
  };
  const extraProps = { autoComplete };
  return /* @__PURE__ */ jsx33(
    FieldInput_default,
    {
      id,
      label: title,
      help,
      description,
      validation: validationState,
      children: /* @__PURE__ */ jsx33(
        SelectInput,
        __spreadValues({
          id,
          items: options.map((option, index) => {
            var _a, _b, _c;
            return {
              type: "option",
              value: index,
              filterMatchers: [
                ...(_a = option.keywords) != null ? _a : [],
                (_b = option.title) != null ? _b : "",
                (_c = option.description) != null ? _c : ""
              ],
              disabled: option.disabled
            };
          }),
          disabled,
          placeholder,
          value: mergedIndices,
          renderValue,
          multiple: true,
          onChange: (values) => {
            setStagedIndices(values);
          },
          onClose: () => {
            if (stagedIndices) {
              onSelect(stagedIndices);
              setStagedIndices(void 0);
            }
          }
        }, extraProps)
      )
    }
  );
}
var MultiSelectInputRenderer_default = MultiSelectInputRenderer;

// ../renderers/src/MultiUploadInputRenderer.tsx
import { UploadInput } from "@transferwise/components";

// ../renderers/src/components/UploadFieldInput.tsx
import { InlineAlert } from "@transferwise/components";
import classNames3 from "classnames";
import { jsx as jsx34, jsxs as jsxs7 } from "react/jsx-runtime";
function UploadFieldInput({
  id,
  children,
  label,
  description,
  help,
  validation
}) {
  const labelContent = label && help ? /* @__PURE__ */ jsx34(LabelContentWithHelp, { text: label, help }) : label;
  const descriptionId = description ? `${id}-description` : void 0;
  return /* @__PURE__ */ jsxs7(
    "div",
    {
      className: classNames3("form-group d-block", {
        "has-error": (validation == null ? void 0 : validation.status) === "invalid"
      }),
      children: [
        /* @__PURE__ */ jsx34("label", { htmlFor: id, className: "control-label", children: labelContent }),
        children,
        (validation == null ? void 0 : validation.status) === "invalid" && /* @__PURE__ */ jsx34(InlineAlert, { type: "negative", id: descriptionId, children: validation.message })
      ]
    }
  );
}
var UploadFieldInput_default = UploadFieldInput;

// ../renderers/src/utils/file-utils.ts
var getAcceptsString = (accepts) => Array.isArray(accepts) && accepts.length >= 1 ? accepts.join(",") : "*";
var toKilobytes = (sizeInBytes) => {
  const ONE_KB_IN_BYTES = 1024;
  return Math.floor(sizeInBytes / ONE_KB_IN_BYTES);
};
var toFile = async (base64Url, name) => {
  const type = getFileType(base64Url);
  const blob = await toBlob(base64Url);
  return new File([blob], name, { type });
};
var toBlob = async (base64Url) => (await fetch(base64Url)).blob();
var getFileType = (base64Url) => {
  const contentTypeRegex = /^data:(.+);/;
  const matches = contentTypeRegex.exec(base64Url);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return void 0;
};

// ../renderers/src/MultiUploadInputRenderer.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var MultiUploadInputRenderer = {
  canRenderType: "input-upload-multi",
  render: (props) => {
    const {
      id,
      accepts,
      help,
      title,
      description,
      disabled,
      maxSize,
      maxItems,
      uploadLabel,
      validationState,
      value,
      onInsertFile,
      onRemoveFile
    } = props;
    const onUploadFile = async (formData) => {
      const file = formData.get("file");
      return onInsertFile(value.length, file).then((newId) => ({ id: newId }));
    };
    const onDeleteFile = async (fileId) => onRemoveFile(value.findIndex((file) => file.id === fileId));
    const descriptionId = description ? `${id}-description` : void 0;
    return /* @__PURE__ */ jsx35(
      UploadFieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx35(
          UploadInput,
          {
            id,
            "aria-describedby": descriptionId,
            description,
            disabled,
            fileTypes: getAcceptsString(accepts),
            maxFiles: maxItems,
            multiple: true,
            sizeLimit: maxSize ? toKilobytes(maxSize) : void 0,
            uploadButtonTitle: uploadLabel,
            onDeleteFile,
            onUploadFile
          }
        )
      }
    );
  }
};
var MultiUploadInputRenderer_default = MultiUploadInputRenderer;

// ../renderers/src/NumberInputRenderer.tsx
import { Input as Input2, InputGroup as InputGroup2 } from "@transferwise/components";
import { jsx as jsx36 } from "react/jsx-runtime";
var NumberInputRenderer = {
  canRenderType: "input-number",
  render: (props) => {
    const { id, title, description, help, icon, image, validationState, value, onChange } = props;
    const commonProps = pick(
      props,
      "disabled",
      "onBlur",
      "onFocus",
      "placeholder",
      "maximum",
      "minimum"
    );
    return /* @__PURE__ */ jsx36(
      FieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx36(InputGroup2, { addonStart: getInputGroupAddonStart({ icon, image }), children: /* @__PURE__ */ jsx36(
          Input2,
          __spreadValues({
            id,
            name: id,
            type: "number",
            value: value != null ? value : "",
            onChange: ({ target: { value: newValue } }) => {
              const parsedValue = Number.parseFloat(newValue);
              onChange(Number.isNaN(parsedValue) ? null : parsedValue);
            },
            onWheel
          }, commonProps)
        ) })
      }
    );
  }
};
var NumberInputRenderer_default = NumberInputRenderer;

// ../renderers/src/ParagraphRenderer.tsx
import { useIntl as useIntl3 } from "react-intl";

// ../renderers/src/hooks/useSnackBarIfAvailable.ts
import { SnackbarContext } from "@transferwise/components";
import { useContext } from "react";
function useSnackBarIfAvailable() {
  const context = useContext(SnackbarContext);
  return context ? context.createSnackbar : () => {
  };
}

// ../renderers/src/ParagraphRenderer.tsx
import { Button as Button3, Input as Input3 } from "@transferwise/components";
import classNames4 from "classnames";

// ../renderers/src/messages/paragraph.messages.ts
import { defineMessages as defineMessages3 } from "react-intl";
var paragraph_messages_default = defineMessages3({
  copy: {
    id: "df.wise.DynamicParagraph.copy",
    defaultMessage: "Copy",
    description: "Copy to clipboard button label."
  },
  copied: {
    id: "df.wise.DynamicParagraph.copied",
    defaultMessage: "Copied to clipboard",
    description: "Appears in a snackbar when the copy operation succeeds."
  }
});

// ../renderers/src/ParagraphRenderer.tsx
import { jsx as jsx37, jsxs as jsxs8 } from "react/jsx-runtime";
var ParagraphRenderer = {
  canRenderType: "paragraph",
  render: (props) => /* @__PURE__ */ jsx37(Paragraph, __spreadValues({}, props))
};
function Paragraph({ align, control, margin, text }) {
  const className = getTextAlignmentAndMargin({ align, margin });
  return control === "copyable" ? /* @__PURE__ */ jsx37(CopyableParagraph, { className, align, text }) : /* @__PURE__ */ jsx37(StandardParagraph, { className, text });
}
function StandardParagraph({ text, className }) {
  return /* @__PURE__ */ jsx37("p", { className: `np-text-body-large ${className}`, children: text });
}
function CopyableParagraph({
  text,
  align,
  className
}) {
  const { formatMessage } = useIntl3();
  const createSnackbar = useSnackBarIfAvailable();
  const copy = () => {
    navigator.clipboard.writeText(text).then(() => createSnackbar({ text: formatMessage(paragraph_messages_default.copied) })).catch(() => {
    });
  };
  const inputAlignmentClasses = getTextAlignmentAndMargin({ align, margin: "sm" });
  return /* @__PURE__ */ jsxs8("div", { className, children: [
    /* @__PURE__ */ jsx37(
      Input3,
      {
        type: "text",
        value: text,
        readOnly: true,
        className: classNames4("text-ellipsis", inputAlignmentClasses)
      }
    ),
    /* @__PURE__ */ jsx37(Button3, { block: true, onClick: copy, children: formatMessage(paragraph_messages_default.copy) })
  ] });
}
var ParagraphRenderer_default = ParagraphRenderer;

// ../renderers/src/RepeatableRenderer.tsx
import { Button as Button4, Header as Header4, InlineAlert as InlineAlert2, Modal as Modal2, NavigationOption as NavigationOption2 } from "@transferwise/components";
import { Plus } from "@transferwise/icons";
import classNames5 from "classnames";
import { useState as useState4 } from "react";
import { useIntl as useIntl4 } from "react-intl";

// ../renderers/src/messages/repeatable.messages.ts
import { defineMessages as defineMessages4 } from "react-intl";
var repeatable_messages_default = defineMessages4({
  addItemTitle: {
    id: "df.wise.ArraySchema.addItemTitle",
    defaultMessage: "Add Item",
    description: "Label on the button used to open a form to add an item"
  },
  addItem: {
    id: "df.wise.ArraySchema.addItem",
    defaultMessage: "Save",
    description: "Label on the add button used to submit a form that adds an item"
  },
  editItem: {
    id: "df.wise.ArraySchema.editItem",
    defaultMessage: "Save",
    description: "Label on the edit button used to submit a form that edits an item"
  },
  removeItem: {
    id: "df.wise.ArraySchema.removeItem",
    defaultMessage: "Remove",
    description: "Label on the remove button used to confirm deletion of an item"
  }
});

// ../renderers/src/RepeatableRenderer.tsx
import { Fragment, jsx as jsx38, jsxs as jsxs9 } from "react/jsx-runtime";
var RepeatableRenderer = {
  canRenderType: "repeatable",
  render: (props) => /* @__PURE__ */ jsx38(Repeatable, __spreadValues({}, props))
};
function Repeatable(props) {
  const {
    addItemTitle,
    description,
    editableItem,
    editItemTitle,
    items,
    title,
    validationState,
    onEdit,
    onAdd,
    onSave,
    onRemove
  } = props;
  const { formatMessage } = useIntl4();
  const [openModalType, setOpenModalType] = useState4(null);
  const onAddItem = () => {
    onAdd();
    setOpenModalType("add");
  };
  const onEditItem = (itemIndex) => {
    onEdit(itemIndex);
    setOpenModalType("edit");
  };
  const onSaveItem = () => {
    const saveSuccessful = onSave();
    if (saveSuccessful) {
      setOpenModalType(null);
    }
  };
  const onRemoveItem = () => {
    onRemove();
    setOpenModalType(null);
  };
  const onCancelEdit = () => {
    setOpenModalType(null);
  };
  return /* @__PURE__ */ jsxs9(Fragment, { children: [
    title && /* @__PURE__ */ jsx38(Header4, { title }),
    description && /* @__PURE__ */ jsx38("p", { children: description }),
    /* @__PURE__ */ jsxs9(
      "div",
      {
        className: classNames5("form-group", {
          "has-error": (validationState == null ? void 0 : validationState.status) === "invalid"
        }),
        children: [
          items == null ? void 0 : items.map((item, index) => /* @__PURE__ */ jsx38(ItemSummaryOption, { item, onClick: () => onEditItem(index) }, item.id)),
          /* @__PURE__ */ jsx38(
            NavigationOption2,
            {
              media: /* @__PURE__ */ jsx38(Plus, {}),
              title: addItemTitle || formatMessage(repeatable_messages_default.addItemTitle),
              showMediaAtAllSizes: true,
              onClick: () => onAddItem()
            }
          ),
          (validationState == null ? void 0 : validationState.status) === "invalid" && /* @__PURE__ */ jsx38(InlineAlert2, { type: "negative", children: validationState.message })
        ]
      }
    ),
    /* @__PURE__ */ jsx38(
      Modal2,
      {
        open: openModalType !== null,
        title: (openModalType === "add" ? addItemTitle : editItemTitle) || formatMessage(repeatable_messages_default.addItemTitle),
        body: /* @__PURE__ */ jsxs9(Fragment, { children: [
          /* @__PURE__ */ jsx38("div", { className: "m-b-2", children: editableItem }),
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx38(Button4, { priority: "primary", block: true, className: "m-b-2", onClick: () => onSaveItem(), children: formatMessage(repeatable_messages_default.addItem) }),
            /* @__PURE__ */ jsx38(Button4, { priority: "secondary", type: "negative", block: true, onClick: () => onRemoveItem(), children: formatMessage(repeatable_messages_default.removeItem) })
          ] })
        ] }),
        onClose: () => onCancelEdit()
      }
    )
  ] });
}
function ItemSummaryOption({
  item,
  onClick
}) {
  return /* @__PURE__ */ jsx38(
    NavigationOption2,
    {
      media: /* @__PURE__ */ jsx38(OptionMedia, __spreadProps(__spreadValues({}, item), { preferAvatar: false })),
      title: item.title,
      content: item.description,
      showMediaAtAllSizes: true,
      onClick
    }
  );
}
var RepeatableRenderer_default = RepeatableRenderer;

// ../renderers/src/SearchRenderer/BlockSearchRendererComponent.tsx
import { Input as Input4, Markdown as Markdown3, NavigationOption as NavigationOption3, NavigationOptionsList as NavigationOptionsList2 } from "@transferwise/components";
import { useState as useState5 } from "react";
import { useIntl as useIntl6 } from "react-intl";

// ../renderers/src/messages/search.messages.ts
import { defineMessages as defineMessages5 } from "react-intl";
var search_messages_default = defineMessages5({
  loading: {
    id: "df.wise.SearchLayout.loading",
    defaultMessage: "Loading...",
    description: "A message shown to the user while their search is being processed, before results appear."
  }
});

// ../renderers/src/SearchRenderer/ErrorResult.tsx
import { useIntl as useIntl5 } from "react-intl";

// ../renderers/src/messages/generic-error.messages.ts
import { defineMessages as defineMessages6 } from "react-intl";
var generic_error_messages_default = defineMessages6({
  genericErrorRetryHint: {
    id: "df.wise.PersistAsyncSchema.genericError",
    defaultMessage: "Something went wrong, please try again.",
    description: "Generic error message for persist async schema"
  },
  genericError: {
    id: "df.wise.ErrorBoundary.errorAlert",
    defaultMessage: "Something went wrong.",
    description: "Generic error message for when something has gone wrong."
  },
  retry: {
    id: "df.wise.ErrorBoundary.retry",
    defaultMessage: "Retry",
    description: "Usually this follows the generic error and contains a link."
  }
});

// ../renderers/src/SearchRenderer/ErrorResult.tsx
import { Button as Button5 } from "@transferwise/components";
import { jsx as jsx39, jsxs as jsxs10 } from "react/jsx-runtime";
function ErrorResult({ state }) {
  const intl = useIntl5();
  const buttonVisualProps = {
    priority: "tertiary",
    size: "sm",
    style: { marginTop: "-2px", padding: "0", width: "auto", display: "inline" }
  };
  return /* @__PURE__ */ jsxs10("p", { className: "m-t-2", children: [
    intl.formatMessage(generic_error_messages_default.genericError),
    "\xA0",
    /* @__PURE__ */ jsx39(
      Button5,
      __spreadProps(__spreadValues({}, buttonVisualProps), {
        onClick: () => {
          state.onRetry();
        },
        children: intl.formatMessage(generic_error_messages_default.retry)
      })
    )
  ] });
}

// ../renderers/src/SearchRenderer/BlockSearchRendererComponent.tsx
import { Fragment as Fragment2, jsx as jsx40, jsxs as jsxs11 } from "react/jsx-runtime";
function BlockSearchRendererComponent({
  id,
  isLoading,
  margin,
  query,
  state,
  title,
  trackEvent,
  onChange
}) {
  const [hasSearched, setHasSearched] = useState5(false);
  const { formatMessage } = useIntl6();
  return /* @__PURE__ */ jsxs11("div", { className: getMargin(margin), children: [
    /* @__PURE__ */ jsx40(FieldInput_default, { id, description: "", validation: void 0, help: "", label: title, children: /* @__PURE__ */ jsx40(
      Input4,
      {
        id,
        name: id,
        type: "text",
        value: query,
        className: "m-t-1",
        onChange: ({ currentTarget: { value } }) => {
          if (!hasSearched) {
            setHasSearched(true);
            trackEvent("Search Started");
          }
          onChange(value);
        }
      }
    ) }),
    isLoading ? /* @__PURE__ */ jsx40(Fragment2, { children: formatMessage(search_messages_default.loading) }) : /* @__PURE__ */ jsx40(SearchResultContent, { state, trackEvent })
  ] });
}
function SearchResultContent({
  state,
  trackEvent
}) {
  switch (state.type) {
    case "error":
      return /* @__PURE__ */ jsx40(ErrorResult, { state });
    case "results":
      return /* @__PURE__ */ jsx40(SearchResults, { state, trackEvent });
    case "noResults":
      return /* @__PURE__ */ jsx40(EmptySearchResult, { state });
    case "pending":
    default:
      return null;
  }
}
function EmptySearchResult({ state }) {
  return /* @__PURE__ */ jsx40(Markdown3, { className: "m-t-2", config: { link: { target: "_blank" } }, children: state.message });
}
function SearchResults({
  state,
  trackEvent
}) {
  return /* @__PURE__ */ jsx40(NavigationOptionsList2, { children: state.results.map((result) => {
    const { icon, image } = result;
    return /* @__PURE__ */ jsx40(
      NavigationOption3,
      {
        title: result.title,
        content: result.description,
        media: OptionMedia({ icon, image, preferAvatar: false }),
        showMediaCircle: false,
        showMediaAtAllSizes: true,
        onClick: () => {
          trackEvent("Search Result Selected", __spreadValues({
            type: result.type
          }, result.type === "action" ? { actionId: result.id } : {}));
          result.onClick();
        }
      },
      JSON.stringify(result)
    );
  }) });
}
var BlockSearchRendererComponent_default = BlockSearchRendererComponent;

// ../renderers/src/SearchRenderer/InlineSearchRendererComponent.tsx
import { Markdown as Markdown4, Typeahead } from "@transferwise/components";
import { Search } from "@transferwise/icons";
import { useState as useState6 } from "react";
import { useIntl as useIntl7 } from "react-intl";
import { jsx as jsx41 } from "react/jsx-runtime";
function InlineSearchRenderer({
  id,
  isLoading,
  margin,
  onChange,
  state,
  title,
  trackEvent
}) {
  const [hasSearched, setHasSearched] = useState6(false);
  const intl = useIntl7();
  return /* @__PURE__ */ jsx41("div", { className: getMargin(margin), children: /* @__PURE__ */ jsx41(FieldInput_default, { id, description: "", validation: void 0, help: "", label: title, children: /* @__PURE__ */ jsx41(
    Typeahead,
    {
      id: "typeahead-input-id",
      intl,
      name: "typeahead-input-name",
      size: "md",
      maxHeight: 100,
      footer: /* @__PURE__ */ jsx41(TypeaheadFooter, { state, isLoading }),
      multiple: false,
      clearable: false,
      addon: /* @__PURE__ */ jsx41(Search, { size: 24 }),
      options: state.type === "results" ? state.results.map(mapResultToTypeaheadOption) : [],
      minQueryLength: 1,
      onChange: (values) => {
        if (values.length > 0) {
          const [updatedValue] = values;
          const { value: result } = updatedValue;
          if (result) {
            trackEvent("Search Result Selected", __spreadValues({
              type: result.type
            }, result.type === "action" ? { actionId: result.id } : {}));
            result.onClick();
          }
        }
      },
      onInputChange: (query) => {
        if (!hasSearched) {
          setHasSearched(true);
          trackEvent("Search Started");
        }
        onChange(query);
      }
    }
  ) }) });
}
function mapResultToTypeaheadOption(result) {
  return {
    label: result.title,
    secondary: result.description,
    value: result,
    clearQueryOnSelect: result.type === "action",
    keepFocusOnSelect: result.type === "search"
  };
}
function TypeaheadFooter({ state, isLoading }) {
  const { formatMessage } = useIntl7();
  if (state.type === "noResults") {
    return /* @__PURE__ */ jsx41(Markdown4, { className: "m-t-2 m-x-2", config: { link: { target: "_blank" } }, children: state.message });
  }
  if (state.type === "error") {
    return /* @__PURE__ */ jsx41("div", { className: "m-t-2 m-x-2", children: /* @__PURE__ */ jsx41(ErrorResult, { state }) });
  }
  if (state.type === "pending" || isLoading) {
    return /* @__PURE__ */ jsx41("p", { className: "m-t-2 m-x-2", children: formatMessage(search_messages_default.loading) });
  }
  return null;
}
var InlineSearchRendererComponent_default = InlineSearchRenderer;

// ../renderers/src/SearchRenderer/SearchRenderer.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var SearchRenderer = {
  canRenderType: "search",
  render: (props) => props.control === "inline" ? /* @__PURE__ */ jsx42(InlineSearchRendererComponent_default, __spreadValues({}, props)) : /* @__PURE__ */ jsx42(BlockSearchRendererComponent_default, __spreadValues({}, props))
};
var SearchRenderer_default = SearchRenderer;

// ../renderers/src/SelectInputRenderer/RadioInputRendererComponent.tsx
import { RadioGroup } from "@transferwise/components";
import { Fragment as Fragment3, jsx as jsx43, jsxs as jsxs12 } from "react/jsx-runtime";
function RadioInputRendererComponent(props) {
  const {
    id,
    children,
    description,
    disabled,
    help,
    title,
    options,
    selectedIndex,
    validationState,
    onSelect
  } = props;
  return /* @__PURE__ */ jsxs12(Fragment3, { children: [
    /* @__PURE__ */ jsx43(
      FieldInput_default,
      {
        id,
        label: title,
        help,
        description,
        validation: validationState,
        children: /* @__PURE__ */ jsx43("span", { children: /* @__PURE__ */ jsx43(
          RadioGroup,
          {
            name: id,
            radios: options.map((option, index) => ({
              label: option.title,
              value: index,
              secondary: option.description,
              disabled: option.disabled || disabled,
              avatar: /* @__PURE__ */ jsx43(OptionMedia, { icon: option.icon, image: option.image, preferAvatar: false })
            })),
            selectedValue: selectedIndex != null ? selectedIndex : void 0,
            onChange: onSelect
          },
          `${id}-${selectedIndex}`
        ) })
      }
    ),
    children
  ] });
}

// ../renderers/src/SelectInputRenderer/TabInputRendererComponent.tsx
import { Tabs } from "@transferwise/components";
import { useEffect as useEffect2 } from "react";
import { Fragment as Fragment4, jsx as jsx44, jsxs as jsxs13 } from "react/jsx-runtime";
function TabInputRendererComponent(props) {
  const {
    id,
    children,
    description,
    disabled,
    help,
    title,
    options,
    selectedIndex,
    validationState,
    onSelect
  } = props;
  useEffect2(() => {
    if (!isValidIndex(selectedIndex, options.length)) {
      onSelect(0);
    }
  }, [selectedIndex, onSelect, options.length]);
  return /* @__PURE__ */ jsxs13(Fragment4, { children: [
    /* @__PURE__ */ jsx44(
      FieldInput_default,
      {
        id,
        label: title,
        help,
        description,
        validation: validationState,
        children: /* @__PURE__ */ jsx44(
          Tabs,
          {
            name: id,
            selected: selectedIndex != null ? selectedIndex : 0,
            tabs: options.map((option) => ({
              title: option.title,
              // if we pass null, we get some props-types console errors
              // eslint-disable-next-line react/jsx-no-useless-fragment
              content: /* @__PURE__ */ jsx44(Fragment4, {}),
              disabled: option.disabled || disabled
            })),
            onTabSelect: onSelect
          }
        )
      }
    ),
    children
  ] });
}
var isValidIndex = (index, options) => index !== null && index >= 0 && index < options;

// ../renderers/src/SelectInputRenderer/SelectInputRendererComponent.tsx
import { SelectInput as SelectInput2, SelectInputOptionContent as SelectInputOptionContent2 } from "@transferwise/components";
import { Fragment as Fragment5, jsx as jsx45, jsxs as jsxs14 } from "react/jsx-runtime";
function SelectInputRendererComponent(props) {
  const {
    id,
    autoComplete,
    children,
    description,
    disabled,
    help,
    title,
    options,
    placeholder,
    required,
    selectedIndex,
    validationState,
    onSelect
  } = props;
  const items = options.map(
    (option, index) => {
      var _a, _b, _c;
      return {
        type: "option",
        value: index,
        filterMatchers: [...(_a = option.keywords) != null ? _a : [], (_b = option.title) != null ? _b : "", (_c = option.description) != null ? _c : ""],
        disabled: option.disabled
      };
    }
  );
  const renderValue = (index, withinTrigger) => {
    const option = index >= 0 ? options[index] : null;
    if (option === null) {
      return null;
    }
    const contentProps = withinTrigger ? {
      title: option.title,
      note: option.description,
      icon: getInlineAvatar(option)
    } : {
      title: option.title,
      description: option.description,
      icon: /* @__PURE__ */ jsx45(OptionMedia, { icon: option.icon, image: option.image, preferAvatar: false })
    };
    return /* @__PURE__ */ jsx45(SelectInputOptionContent2, __spreadValues({}, contentProps));
  };
  const extraProps = { autoComplete };
  return /* @__PURE__ */ jsxs14(Fragment5, { children: [
    /* @__PURE__ */ jsx45(
      FieldInput_default,
      {
        id,
        label: title,
        help,
        description,
        validation: validationState,
        children: /* @__PURE__ */ jsx45(
          SelectInput2,
          __spreadValues({
            name: id,
            placeholder,
            items,
            disabled,
            value: selectedIndex,
            renderValue,
            filterable: items.length >= 8,
            onChange: onSelect,
            onClear: required ? void 0 : () => onSelect(null)
          }, extraProps)
        )
      }
    ),
    children
  ] });
}

// ../renderers/src/SelectInputRenderer/SegmentedInputRendererComponent.tsx
import { useEffect as useEffect3 } from "react";
import { SegmentedControl } from "@transferwise/components";
import { Fragment as Fragment6, jsx as jsx46, jsxs as jsxs15 } from "react/jsx-runtime";
function SegmentedInputRendererComponent(props) {
  const {
    id,
    children,
    description,
    help,
    title,
    options,
    selectedIndex,
    validationState,
    onSelect
  } = props;
  useEffect3(() => {
    if (!isValidIndex2(selectedIndex, options.length)) {
      onSelect(0);
    }
  }, [selectedIndex, onSelect, options.length]);
  return /* @__PURE__ */ jsxs15(Fragment6, { children: [
    /* @__PURE__ */ jsx46(
      FieldInput_default,
      {
        id,
        label: title,
        help,
        description,
        validation: validationState,
        children: /* @__PURE__ */ jsx46(
          SegmentedControl,
          {
            name: `${id}-segmented-control`,
            value: String(selectedIndex),
            mode: "view",
            segments: options.map((option, index) => ({
              id: String(index),
              value: String(index),
              label: option.title,
              controls: `${id}-children`
            })),
            onChange: (value) => onSelect(Number(value))
          }
        )
      }
    ),
    /* @__PURE__ */ jsx46("div", { id: `${id}-children`, children })
  ] });
}
var isValidIndex2 = (index, options) => index !== null && index >= 0 && index < options;

// ../renderers/src/SelectInputRenderer/SelectInputRenderer.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var SelectInputRenderer = {
  canRenderType: "input-select",
  render: (props) => {
    switch (props.control) {
      case "radio":
        return /* @__PURE__ */ jsx47(RadioInputRendererComponent, __spreadValues({}, props));
      case "tab":
        return props.options.length > 3 ? /* @__PURE__ */ jsx47(SelectInputRendererComponent, __spreadValues({}, props)) : /* @__PURE__ */ jsx47(TabInputRendererComponent, __spreadValues({}, props));
      case "segmented":
        return props.options.length > 3 ? /* @__PURE__ */ jsx47(SelectInputRendererComponent, __spreadValues({}, props)) : /* @__PURE__ */ jsx47(SegmentedInputRendererComponent, __spreadValues({}, props));
      case "select":
      default:
        return /* @__PURE__ */ jsx47(SelectInputRendererComponent, __spreadValues({}, props));
    }
  }
};
var SelectInputRenderer_default = SelectInputRenderer;

// ../renderers/src/StatusListRenderer.tsx
import { Header as Header5, Summary } from "@transferwise/components";
import { jsx as jsx48, jsxs as jsxs16 } from "react/jsx-runtime";
var StatusListRenderer = {
  canRenderType: "status-list",
  render: ({ margin, items, title }) => /* @__PURE__ */ jsxs16("div", { className: getMargin(margin), children: [
    title ? /* @__PURE__ */ jsx48(Header5, { title, className: "m-b-2" }) : null,
    items.map(({ callToAction, description, icon, status, title: itemTitle }) => /* @__PURE__ */ jsx48(
      Summary,
      {
        title: itemTitle,
        description,
        icon: icon && "name" in icon ? /* @__PURE__ */ jsx48(DynamicIcon_default, { name: icon.name }) : null,
        status: mapStatus(status),
        action: getSummaryAction(callToAction)
      },
      `${itemTitle}/${description || ""}`
    ))
  ] })
};
var StatusListRenderer_default = StatusListRenderer;
var getSummaryAction = (callToAction) => {
  if (!callToAction) {
    return void 0;
  }
  const { accessibilityDescription, href, title, onClick } = callToAction;
  if (!href) {
    return {
      "aria-label": accessibilityDescription,
      text: title,
      onClick
    };
  }
  return {
    "aria-label": accessibilityDescription,
    href,
    target: "_blank",
    text: title
  };
};
var mapStatus = (status) => {
  if (status === "not-done") {
    return "notDone";
  }
  return status;
};

// ../renderers/src/TextInputRenderer.tsx
import { InputGroup as InputGroup3 } from "@transferwise/components";

// ../renderers/src/components/VariableTextInput.tsx
import {
  Input as Input5,
  InputWithDisplayFormat,
  PhoneNumberInput,
  TextArea,
  TextareaWithDisplayFormat
} from "@transferwise/components";
import { jsx as jsx49 } from "react/jsx-runtime";
var commonKeys = [
  "autoComplete",
  "autoCapitalize",
  "placeholder",
  "control",
  "disabled",
  "displayFormat",
  "id",
  "onBlur",
  "onFocus",
  "placeholder",
  "value"
];
function VariableTextInput(inputProps) {
  const { id, value, control, onChange } = inputProps;
  const commonProps = __spreadProps(__spreadValues({}, pick(inputProps, ...commonKeys)), { name: id });
  switch (control) {
    case "email":
      return /* @__PURE__ */ jsx49(TextInput, __spreadProps(__spreadValues({}, commonProps), { type: "email", onChange }));
    case "password":
      return /* @__PURE__ */ jsx49(TextInput, __spreadProps(__spreadValues({}, commonProps), { type: "password", onChange }));
    case "numeric": {
      const numericProps = __spreadProps(__spreadValues({}, commonProps), { type: "number", onWheel });
      return /* @__PURE__ */ jsx49(
        TextInput,
        __spreadProps(__spreadValues({}, numericProps), {
          onChange: (newValue) => onChange(numericValueOrNull(newValue))
        })
      );
    }
    case "phone-number":
      return /* @__PURE__ */ jsx49(PhoneNumberInput, __spreadProps(__spreadValues({ initialValue: value }, commonProps), { onChange }));
    default: {
      return /* @__PURE__ */ jsx49(TextInput, __spreadProps(__spreadValues({}, commonProps), { type: "text", onChange }));
    }
  }
}
function TextInput(props) {
  const _a = props, { control, displayFormat, onChange } = _a, commonProps = __objRest(_a, ["control", "displayFormat", "onChange"]);
  const InputWithPattern = control === "textarea" ? TextareaWithDisplayFormat : InputWithDisplayFormat;
  const InputWithoutPattern = control === "textarea" ? TextArea : Input5;
  return displayFormat ? /* @__PURE__ */ jsx49(InputWithPattern, __spreadProps(__spreadValues({ displayPattern: displayFormat }, commonProps), { onChange })) : /* @__PURE__ */ jsx49(InputWithoutPattern, __spreadProps(__spreadValues({}, commonProps), { onChange: (e) => onChange(e.target.value) }));
}

// ../renderers/src/TextInputRenderer.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var TextInputRenderer = {
  canRenderType: "input-text",
  render: (props) => {
    const _a = props, {
      id,
      title,
      description,
      help,
      icon,
      image,
      validationState,
      value: initialValue,
      onChange
    } = _a, rest = __objRest(_a, [
      "id",
      "title",
      "description",
      "help",
      "icon",
      "image",
      "validationState",
      "value",
      "onChange"
    ]);
    const value = initialValue != null ? initialValue : "";
    const inputProps = __spreadProps(__spreadValues({}, rest), {
      value,
      id,
      onChange: (newValue) => {
        if ((value != null ? value : "") !== (newValue != null ? newValue : "")) {
          onChange(newValue);
        }
      }
    });
    return /* @__PURE__ */ jsx50(
      FieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx50(InputGroup3, { addonStart: getInputGroupAddonStart({ icon, image }), children: /* @__PURE__ */ jsx50(VariableTextInput, __spreadValues({}, inputProps)) })
      }
    );
  }
};
var TextInputRenderer_default = TextInputRenderer;

// ../renderers/src/UploadInputRenderer.tsx
import { Upload, UploadInput as UploadInput2 } from "@transferwise/components";

// ../renderers/src/utils/getRandomId.ts
var getRandomId = () => Math.random().toString(36).substring(2);

// ../renderers/src/UploadInputRenderer.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var UploadInputRenderer = {
  canRenderType: "input-upload",
  render: (props) => {
    const { id, accepts, title, description, disabled, maxSize, validationState, onUpload } = props;
    const onUploadFile = async (formData) => {
      const file = formData.get("file");
      return onUpload(file).then(() => ({
        id: getRandomId()
      }));
    };
    const onDeleteFile = async () => {
      await onUpload(null);
    };
    return (
      // We don't pass help here as there is no sensible place to display it
      /* @__PURE__ */ jsx51(
        UploadFieldInput_default,
        {
          id,
          label: void 0,
          description: void 0,
          validation: validationState,
          children: /* @__PURE__ */ jsx51(
            UploadInput2,
            {
              id,
              description,
              disabled,
              fileTypes: getAcceptsString(accepts),
              sizeLimit: maxSize ? toKilobytes(maxSize) : void 0,
              uploadButtonTitle: title,
              onDeleteFile,
              onUploadFile
            }
          )
        }
      )
    );
  }
};
var LargeUploadRenderer = {
  canRenderType: "input-upload",
  canRender: (props) => props.control === "upload-large",
  render: (props) => {
    const _a = props, {
      id,
      accepts,
      control,
      title,
      description,
      disabled,
      help,
      maxSize,
      type,
      validationState,
      onUpload
    } = _a, rest = __objRest(_a, [
      "id",
      "accepts",
      "control",
      "title",
      "description",
      "disabled",
      "help",
      "maxSize",
      "type",
      "validationState",
      "onUpload"
    ]);
    const uploadProps = __spreadProps(__spreadValues({}, rest), { id, name: id });
    const onUploadFile = async (file, fileName) => {
      try {
        const convertedFile = file ? await toFile(file, fileName) : null;
        await onUpload(convertedFile);
      } catch (e) {
        await onUpload(null);
        throw e;
      }
    };
    return /* @__PURE__ */ jsx51(
      FieldInput_default,
      {
        id,
        label: title,
        description,
        validation: validationState,
        help,
        children: /* @__PURE__ */ jsx51(
          Upload,
          __spreadProps(__spreadValues({}, uploadProps), {
            usAccept: getAcceptsString(accepts),
            usDisabled: disabled,
            onSuccess: onUploadFile,
            onFailure: async () => onUpload(null),
            onCancel: async () => onUpload(null)
          })
        )
      }
    );
  }
};

// ../renderers/src/ReviewRenderer.tsx
import { DefinitionList, Header as Header6 } from "@transferwise/components";
import { Fragment as Fragment7, jsx as jsx52, jsxs as jsxs17 } from "react/jsx-runtime";
var ReviewRenderer = {
  canRenderType: "review",
  render: ({ callToAction, control, fields, margin, title }) => {
    const orientation = mapControlToDefinitionListLayout(control);
    return /* @__PURE__ */ jsxs17("div", { className: getMargin(margin), children: [
      (title || callToAction) && /* @__PURE__ */ jsx52(Header6, { title: title != null ? title : "", action: getReviewAction(callToAction) }),
      /* @__PURE__ */ jsx52("div", { className: margin, children: /* @__PURE__ */ jsx52(
        DefinitionList,
        {
          layout: orientation,
          definitions: fields.map(({ label, value, help }, index) => ({
            key: String(index),
            title: label,
            value: getFieldValue(value, help, orientation)
          }))
        }
      ) })
    ] });
  }
};
var ReviewRenderer_default = ReviewRenderer;
var mapControlToDefinitionListLayout = (control) => {
  switch (control) {
    case "horizontal":
    case "horizontal-end-aligned":
      return "HORIZONTAL_RIGHT_ALIGNED";
    case "horizontal-start-aligned":
      return "HORIZONTAL_LEFT_ALIGNED";
    case "vertical-two-column":
      return "VERTICAL_TWO_COLUMN";
    case "vertical":
    case "vertical-one-column":
    default:
      return "VERTICAL_ONE_COLUMN";
  }
};
var getFieldValue = (value, help, orientation) => {
  if (help) {
    return orientation === "HORIZONTAL_RIGHT_ALIGNED" ? /* @__PURE__ */ jsxs17(Fragment7, { children: [
      /* @__PURE__ */ jsx52(Help_default, { help }),
      " ",
      value
    ] }) : /* @__PURE__ */ jsxs17(Fragment7, { children: [
      value,
      " ",
      /* @__PURE__ */ jsx52(Help_default, { help })
    ] });
  }
  return value;
};
var getReviewAction = (callToAction) => {
  if (!callToAction) {
    return void 0;
  }
  const { accessibilityDescription, href, title, onClick } = callToAction;
  if (!href) {
    return {
      "aria-label": accessibilityDescription,
      text: title,
      onClick: (event) => {
        event.preventDefault();
        onClick();
      }
    };
  }
  return {
    "aria-label": accessibilityDescription,
    href,
    target: "_blank",
    text: title
  };
};

// ../renderers/src/step/StepRenderer.tsx
import { Alert as Alert2, Title } from "@transferwise/components";

// ../renderers/src/step/BackButton.tsx
import { AvatarView as AvatarView4 } from "@transferwise/components";
import { ArrowLeft } from "@transferwise/icons";
import { jsx as jsx53, jsxs as jsxs18 } from "react/jsx-runtime";
function BackButton({ title, onClick }) {
  return /* @__PURE__ */ jsx53("div", { className: "m-b-2", children: /* @__PURE__ */ jsxs18(
    "button",
    {
      type: "button",
      className: "df-back-btn",
      title,
      "aria-label": title,
      onClick,
      children: [
        /* @__PURE__ */ jsx53("span", { className: "sr-only", children: title }),
        /* @__PURE__ */ jsx53(AvatarView4, { interactive: true, children: /* @__PURE__ */ jsx53(ArrowLeft, { size: "24" }) })
      ]
    }
  ) });
}
var BackButton_default = BackButton;

// ../renderers/src/step/ExternalConfirmationDialog.tsx
import { useIntl as useIntl8 } from "react-intl";

// ../renderers/src/messages/external-confirmation.messages.ts
import { defineMessages as defineMessages7 } from "react-intl";
var external_confirmation_messages_default = defineMessages7({
  title: {
    id: "df.wise.ExternalConfirmation.title",
    defaultMessage: "Please confirm",
    description: "Heading for the confirmation screen."
  },
  description: {
    id: "df.wise.ExternalConfirmation.description",
    defaultMessage: "Please confirm you want to open **{origin}** in a new browser tab.",
    description: "Description for the confirmation screen."
  },
  open: {
    id: "df.wise.ExternalConfirmation.open",
    defaultMessage: "Open in new tab",
    description: "Button text confirming opening a new browser tab."
  },
  cancel: {
    id: "df.wise.ExternalConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Button text rejecting opening a new browser tab."
  }
});

// ../renderers/src/step/ExternalConfirmationDialog.tsx
import { Button as Button6, Markdown as Markdown5 } from "@transferwise/components";
import { jsx as jsx54, jsxs as jsxs19 } from "react/jsx-runtime";
function ExternalConfirmationDialog({
  external,
  onClose
}) {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ jsx54("div", { className: "df-box-renderer-fixed-width", children: /* @__PURE__ */ jsxs19("div", { className: "df-box-renderer-width-lg", children: [
    /* @__PURE__ */ jsx54("h2", { className: "text-xs-center m-b-5", children: formatMessage(external_confirmation_messages_default.title) }),
    /* @__PURE__ */ jsx54(Markdown5, { config: { link: { target: "_blank" } }, className: "text-xs-center m-b-5", children: formatMessage(external_confirmation_messages_default.description, { origin: getOrigin(external.url) }) }),
    /* @__PURE__ */ jsx54("div", { className: "df-box-renderer-fixed-width", children: /* @__PURE__ */ jsxs19("div", { className: "df-box-renderer-width-lg", children: [
      /* @__PURE__ */ jsx54(
        Button6,
        {
          block: true,
          className: "m-b-2",
          priority: "primary",
          size: "md",
          onClick: () => {
            window.open(external.url);
            onClose();
          },
          children: formatMessage(external_confirmation_messages_default.open)
        }
      ),
      /* @__PURE__ */ jsx54(Button6, { block: true, className: "m-b-2", priority: "tertiary", size: "md", onClick: onClose, children: formatMessage(external_confirmation_messages_default.cancel) })
    ] }) })
  ] }) });
}
function getOrigin(url) {
  try {
    return new URL(url).origin;
  } catch (e) {
    return url;
  }
}

// ../renderers/src/step/useExternal.tsx
import { useEffect as useEffect4, useState as useState7 } from "react";
function useExternal(url) {
  const [externalWindow, setExternalWindow] = useState7(null);
  const [hasDismissed, setHasDismissed] = useState7(false);
  const dismissConfirmation = () => setHasDismissed(true);
  useEffect4(() => {
    if (url) {
      setHasDismissed(false);
      setExternalWindow(window.open(url, "_blank"));
    }
  }, [url]);
  const requiresUserConfirmation = Boolean(url && !externalWindow && !hasDismissed);
  return { requiresUserConfirmation, dismissConfirmation };
}

// ../renderers/src/step/StepRenderer.tsx
import { Fragment as Fragment8, jsx as jsx55, jsxs as jsxs20 } from "react/jsx-runtime";
var StepRenderer = {
  canRenderType: "step",
  render: StepRendererComponent
};
function StepRendererComponent(props) {
  const { back, description, error, external, title, children } = props;
  const { requiresUserConfirmation, dismissConfirmation } = useExternal(external == null ? void 0 : external.url);
  if ((external == null ? void 0 : external.url) && requiresUserConfirmation) {
    return /* @__PURE__ */ jsx55(ExternalConfirmationDialog, { external, onClose: dismissConfirmation });
  }
  return /* @__PURE__ */ jsxs20(Fragment8, { children: [
    back ? /* @__PURE__ */ jsx55(BackButton_default, __spreadValues({}, back)) : null,
    title || description ? /* @__PURE__ */ jsxs20("div", { className: "m-b-4", children: [
      title ? /* @__PURE__ */ jsx55(Title, { as: "h1", type: "title-section", className: "text-xs-center m-b-2", children: title }) : void 0,
      description ? /* @__PURE__ */ jsx55("p", { className: "text-xs-center np-text-body-large", children: description }) : void 0
    ] }) : void 0,
    error ? /* @__PURE__ */ jsx55(Alert2, { type: "negative", className: "m-b-2", message: error }) : void 0,
    children
  ] });
}

// ../renderers/src/ListRenderer.tsx
import { Body, Header as Header7 } from "@transferwise/components";
import classNames6 from "classnames";
import { jsx as jsx56, jsxs as jsxs21 } from "react/jsx-runtime";
var ListRenderer = {
  canRenderType: "list",
  render: ({ callToAction, control, margin, items, title }) => /* @__PURE__ */ jsxs21("div", { className: getMargin(margin), children: [
    (title || callToAction) && /* @__PURE__ */ jsx56(Header7, { as: "h2", title: title != null ? title : "", action: getListAction(callToAction) }),
    items.map((props) => /* @__PURE__ */ jsx56(DesignSystemListItem, __spreadProps(__spreadValues({}, props), { control }), props.title))
  ] })
};
var DesignSystemListItem = ({
  title,
  subtitle,
  value,
  subvalue,
  icon,
  image,
  control
}) => /* @__PURE__ */ jsx56(
  "label",
  {
    className: classNames6("np-option p-a-2", {
      "np-option__sm-media": true,
      "np-option__container-aligned": true
    }),
    children: /* @__PURE__ */ jsxs21("div", { className: "media", children: [
      icon || image ? /* @__PURE__ */ jsx56("div", { className: "media-left", children: /* @__PURE__ */ jsx56(ListItemMedia, { image, icon, preferAvatar: control === "with-avatar" }) }) : null,
      /* @__PURE__ */ jsxs21("div", { className: "media-body", children: [
        /* @__PURE__ */ jsxs21("div", { className: "d-flex justify-content-between", children: [
          /* @__PURE__ */ jsx56("h4", { className: "np-text-body-large-bold text-primary np-option__title", children: title }),
          /* @__PURE__ */ jsx56("h4", { className: "np-text-body-large-bold text-primary np-option__title", children: value })
        ] }),
        /* @__PURE__ */ jsxs21("div", { className: "d-flex justify-content-between", children: [
          /* @__PURE__ */ jsx56(Body, { className: "d-block np-option__body", children: subtitle }),
          /* @__PURE__ */ jsx56(Body, { className: "d-block np-option__body", children: subvalue })
        ] })
      ] })
    ] })
  },
  title
);
var ListItemMedia = ({
  icon,
  image,
  preferAvatar
}) => {
  if (icon) {
    return /* @__PURE__ */ jsx56("div", { className: "circle circle-sm text-primary circle-inverse", children: /* @__PURE__ */ jsx56(OptionMedia, { icon, image, preferAvatar }) });
  }
  if (image) {
    return /* @__PURE__ */ jsx56("div", { className: "np-option__no-media-circle", children: /* @__PURE__ */ jsx56(OptionMedia, { icon, image, preferAvatar }) });
  }
};
var getListAction = (callToAction) => {
  if (!callToAction) {
    return void 0;
  }
  const { accessibilityDescription, title, onClick } = callToAction;
  if (callToAction.type === "action") {
    return {
      "aria-label": accessibilityDescription,
      text: title,
      onClick: (event) => {
        event.preventDefault();
        onClick();
      }
    };
  }
  return {
    "aria-label": accessibilityDescription,
    href: callToAction.href,
    target: "_blank",
    text: title
  };
};
var ListRenderer_default = ListRenderer;

// ../renderers/src/step/SplashStepRenderer.tsx
import { jsx as jsx57, jsxs as jsxs22 } from "react/jsx-runtime";
var SplashStepRenderer = {
  canRenderType: "step",
  canRender: ({ control }) => control === "splash",
  render: SplashStepRendererComponent
};
function SplashStepRendererComponent(props) {
  const { back, children, external } = props;
  const { requiresUserConfirmation, dismissConfirmation } = useExternal(external == null ? void 0 : external.url);
  if ((external == null ? void 0 : external.url) && requiresUserConfirmation) {
    return /* @__PURE__ */ jsx57(ExternalConfirmationDialog, { external, onClose: dismissConfirmation });
  }
  return /* @__PURE__ */ jsxs22("div", { className: "splash-screen m-t-5", children: [
    back ? /* @__PURE__ */ jsx57(BackButton_default, __spreadValues({}, back)) : null,
    children
  ] });
}

// ../renderers/src/utils/useCustomTheme.ts
import { useTheme } from "@wise/components-theming";
import { useEffect as useEffect5, useMemo } from "react";
var ThemeRequiredEventName = "Theme Required";
var useCustomTheme = (theme, trackEvent) => {
  const previousThemeHookValue = useTheme();
  const previousTheme = useMemo(() => previousThemeHookValue.theme, []);
  useEffect5(() => {
    trackEvent(ThemeRequiredEventName, { theme });
    return theme !== previousTheme ? () => {
      trackEvent(ThemeRequiredEventName, { theme: previousTheme });
    } : () => {
    };
  }, []);
};

// ../renderers/src/step/SplashCelebrationStepRenderer.tsx
import { jsx as jsx58, jsxs as jsxs23 } from "react/jsx-runtime";
var SplashCelebrationStepRenderer = {
  canRenderType: "step",
  canRender: ({ control }) => control === "splash-celebration",
  render: SplashCelebrationStepRendererComponent
};
function SplashCelebrationStepRendererComponent(props) {
  const { back, children, external, trackEvent } = props;
  useCustomTheme("forest-green", trackEvent);
  const { requiresUserConfirmation, dismissConfirmation } = useExternal(external == null ? void 0 : external.url);
  if ((external == null ? void 0 : external.url) && requiresUserConfirmation) {
    return /* @__PURE__ */ jsx58(ExternalConfirmationDialog, { external, onClose: dismissConfirmation });
  }
  return /* @__PURE__ */ jsxs23("div", { className: "splash-screen m-t-5", children: [
    back ? /* @__PURE__ */ jsx58(BackButton_default, __spreadValues({}, back)) : null,
    children
  ] });
}

// ../renderers/src/getWiseRenderers.ts
var getWiseRenderers = () => [
  AlertRenderer_default,
  CheckboxInputRenderer_default,
  BoxRenderer_default,
  ButtonRenderer_default,
  ColumnsRenderer_default,
  DateInputRenderer_default,
  DecisionRenderer_default,
  DividerRenderer_default,
  FormRenderer_default,
  FormSectionRenderer_default,
  HeadingRenderer_default,
  ImageRenderer_default,
  InstructionsRenderer_default,
  IntegerInputRenderer_default,
  LargeUploadRenderer,
  ListRenderer_default,
  LoadingIndicatorRenderer_default,
  MarkdownRenderer_default,
  ModalRenderer_default,
  MultiSelectInputRenderer_default,
  MultiUploadInputRenderer_default,
  NumberInputRenderer_default,
  ParagraphRenderer_default,
  RepeatableRenderer_default,
  ReviewRenderer_default,
  SearchRenderer_default,
  SelectInputRenderer_default,
  StatusListRenderer_default,
  TextInputRenderer_default,
  UploadInputRenderer,
  SplashStepRenderer,
  SplashCelebrationStepRenderer,
  StepRenderer
];

// src/dynamicFlow/telemetry/app-version.ts
var appVersion = "4.9.2";

// src/dynamicFlow/telemetry/getLogEvent.ts
var getLogEvent = (onLog) => (level, message, extra) => {
  const extraWithVersion = __spreadProps(__spreadValues({}, extra), {
    dfWiseVersion: appVersion
  });
  if (level !== "info" && onLog) {
    if (onLog) {
      onLog(level, message, extraWithVersion);
    } else {
      logToRollbar(level, message, extraWithVersion);
    }
  }
};
var logToRollbar = (level, message, extra) => {
  try {
    const rollbar = typeof window.Rollbar !== "undefined" ? window.Rollbar : void 0;
    rollbar == null ? void 0 : rollbar[level](message, extra);
  } catch (error) {
    console.error("Failed to log to Rollbar", error);
  }
};

// src/dynamicFlow/telemetry/getTrackEvent.ts
import { isThemeModern } from "@wise/components-theming";
var getTrackEvent = (onEvent, onAnalytics, onThemeChange) => (name, properties) => {
  onEvent == null ? void 0 : onEvent(name, properties);
  if (name.includes(ThemeRequiredEventName)) {
    const { theme } = properties != null ? properties : { theme: "personal" };
    if (theme && isThemeModern(theme)) {
      onThemeChange == null ? void 0 : onThemeChange(theme);
    }
  } else {
    onAnalytics == null ? void 0 : onAnalytics(name, properties);
  }
};

// src/dynamicFlow/DynamicFlow.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
var wiseRenderers = getWiseRenderers();
function DynamicFlowLegacy(props) {
  const { customFetch = globalThis.fetch } = props;
  const coreProps = __spreadProps(__spreadValues({}, props), { httpClient: customFetch });
  return /* @__PURE__ */ jsx59(DynamicFlowCoreLegacy, __spreadValues({}, coreProps));
}
function DynamicFlowRevamp(props) {
  const {
    customFetch = globalThis.fetch,
    renderers,
    onAnalytics,
    onEvent,
    onLog,
    onLink = openLinkInNewTab,
    onThemeChange
  } = props;
  const httpClient = useWiseHttpClient(customFetch);
  const mergedRenderers = useMemo2(() => [...renderers != null ? renderers : [], ...wiseRenderers], [renderers]);
  const logEvent = useMemo2(() => getLogEvent(onLog), [onLog]);
  const trackEvent = useMemo2(
    () => getTrackEvent(onEvent, onAnalytics, onThemeChange),
    [onEvent, onAnalytics, onThemeChange]
  );
  const coreProps = __spreadProps(__spreadValues({}, props), {
    httpClient,
    renderers: mergedRenderers,
    onEvent: trackEvent,
    onLog: logEvent,
    onLink
  });
  return /* @__PURE__ */ jsx59(DynamicFlowCoreRevamp, __spreadValues({}, coreProps));
}
var DynamicForm = forwardRef(function DynamicForm2(props, ref) {
  const {
    customFetch = globalThis.fetch,
    renderers,
    onAnalytics,
    onEvent,
    onLog,
    onLink = openLinkInNewTab,
    onThemeChange
  } = props;
  const httpClient = useWiseHttpClient(customFetch);
  const mergedRenderers = useMemo2(() => [...renderers != null ? renderers : [], ...wiseRenderers], [renderers]);
  const logEvent = useMemo2(() => getLogEvent(onLog), [onLog]);
  const trackEvent = useMemo2(
    () => getTrackEvent(onEvent, onAnalytics, onThemeChange),
    [onEvent, onAnalytics, onThemeChange]
  );
  const coreProps = __spreadProps(__spreadValues({}, props), {
    httpClient,
    renderers: mergedRenderers,
    onEvent: trackEvent,
    onLog: logEvent,
    onLink
  });
  return /* @__PURE__ */ jsx59(DynamicFormCore, __spreadProps(__spreadValues({}, coreProps), { ref }));
});
var useWiseHttpClient = (httpClient) => {
  const { locale } = useIntl9();
  return useCallback(
    async (input, init = {}) => {
      const headers = new Headers(init.headers);
      headers.set("accept-language", locale);
      return httpClient(input, __spreadProps(__spreadValues({}, init), { credentials: "include", headers }));
    },
    [httpClient, locale]
  );
};
var openLinkInNewTab = (url) => {
  var _a;
  try {
    const w = (_a = window == null ? void 0 : window.open) == null ? void 0 : _a.call(window, url, "_blank");
    return Boolean(w);
  } catch (e) {
    return false;
  }
};
export {
  DynamicFlowLegacy,
  DynamicFlowRevamp,
  DynamicForm,
  JsonSchemaForm,
  findRendererPropsByType,
  isValidSchema,
  makeHttpClient as makeCustomFetch,
  i18n_default as translations
};
